import React, { useEffect, useState, useRef } from 'react';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import ImageUploader from '../../../components/ImageUploader';
import { CommonCropperModal } from '../../common/vhelper/commonCropperModal';
import './OnboardingSetup.css';
import { Link } from 'react-router-dom';
import Logo from '../../../components/Logomenu';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Button from '../../../components/bootstrap/Button';
import Popovers from '../../../components/bootstrap/Popovers';
import LANG, { getLangWithKey } from '../../../lang';
import { useTranslation } from 'react-i18next';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import { ClockCircleOutlined } from '@ant-design/icons';
import '../demo-pages/time-picker-override.css';
import Select from '../../../components/bootstrap/forms/Select';
import InputGroup, { InputGroupText } from '../../../components/bootstrap/forms/InputGroup';
import Paypal from '../../../assets/img/paypal.svg';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import { Ralert } from '../../common/vhelper/Normarodallalert';
import apiServicewt from '../../../api/apiServicewt';
import PhoneNumberInput from '../demo-pages/helper/PhoneNumberInput';
import CommonImageApiService from '../../../api/uploadImageApiService';
import { Link as RouterLink } from 'react-router-dom';

const steps = ['Welcome', 'Business Info', 'Choose Plan', 'Review', 'Confirmation'];

const defaultBusinessInfo = {
	salonName: '',
	projectSlug: '',
	ownerName: '',
	ownerLastName: '',
	city: '',
	state: '',
	postal_code: '',
	address: '',
	address2: '',
	country: '',
	contactNumber: '',
	whatsappNumber: '',
	email: '',
	businessType: '',
	businessTypeOther: '',
	taxId: '',
	currency: 'USD',
	gstVatTaxId: '',
	language: 'English',
	hours: [{ day: 'Monday', open: '', close: '' }],
	logoWhite: [],
	logoDark: [],
	logoMobile: [],
	favicon: [],
};

const ONBOARDING_STORAGE_KEY = 'onboarding-setup-state-v1';

const OnboardingSetup = () => {
	useEffect(() => {
		document.body.classList.add('onboarding-scroll-lock');
		return () => {
			document.body.classList.remove('onboarding-scroll-lock');
		};
	}, []);

	const [cropperOpen, setCropperOpen] = useState(false);
	const [cropperImg, setCropperImg] = useState(null);
	const [cropperImgFile, setCropperImgFile] = useState(null);
	const [cropperTarget, setCropperTarget] = useState(null);
	const saved = (() => {
		try {
			const raw = localStorage.getItem(ONBOARDING_STORAGE_KEY);
			return raw ? JSON.parse(raw) : null;
		} catch {
			return null;
		}
	})();

	const [step, setStep] = useState(saved?.step ?? 0);
	const [businessInfo, setBusinessInfo] = useState(
		saved?.businessInfo
			? { ...defaultBusinessInfo, ...saved.businessInfo }
			: defaultBusinessInfo,
	);
	const [selectedPlan, setSelectedPlan] = useState(saved?.selectedPlan ?? null);
	const [domainOption, setDomainOption] = useState(saved?.domainOption ?? 'temporary');
	const [customDomains, setCustomDomains] = useState(
		saved?.customDomains ?? {
			customer: '',
			employee: '',
			business: '',
			webapi: '',
			cdn: '',
		},
	);
	const [tempDomains, setTempDomains] = useState(
		saved?.tempDomains ?? {
			customer: '',
			employee: '',
			business: '',
			webapi: '',
			cdn: '',
		},
	);
	const [reviewAccepted, setReviewAccepted] = useState(saved?.reviewAccepted ?? false);
	const [termsAccepted, setTermsAccepted] = useState(saved?.termsAccepted ?? false);
	const [paymentOption, setPaymentOption] = useState(saved?.paymentOption ?? 'trial');
	const [bankReceipt, setBankReceipt] = useState(saved?.bankReceipt ?? []);
	const [errors, setErrors] = useState({});
	const [submitting, setSubmitting] = useState(false);
	const [salonNameValid, setSalonNameValid] = useState(false);
	const [salonNameChecking, setSalonNameChecking] = useState(false);
	const [salonNameError, setSalonNameError] = useState('');
	const [salonNameLastChecked, setSalonNameLastChecked] = useState('');
	const [projectSlugValid, setProjectSlugValid] = useState(false);
	const [projectSlugChecking, setProjectSlugChecking] = useState(false);
	const [projectSlugError, setProjectSlugError] = useState('');
	const [projectSlugLastChecked, setProjectSlugLastChecked] = useState('');
	const validationSeqRef = useRef(0);
	const debounceTimerRef = useRef(null);
	const lastRequestedSlugRef = useRef('');
	const slugEditedRef = useRef(false);
	const [billingPeriod, setBillingPeriod] = useState(saved?.billingPeriod ?? 'monthly');
	const [bankInputKey, setBankInputKey] = useState(Date.now());
	const [paymentMethod, setPaymentMethod] = useState(saved?.paymentMethod ?? 'bank');
	const [localBankReceipt, setLocalBankReceipt] = useState(saved?.localBankReceipt ?? []);
	const [bankReceiptError, setBankReceiptError] = useState('');
	const [bankUploading, setBankUploading] = useState(false);
	const [bankDragActive, setBankDragActive] = useState(false);
	const bankFileInputRef = useRef(null);
	const [previewImg, setPreviewImg] = useState(null);
	const [emailVerifyOpen, setEmailVerifyOpen] = useState(false);
	const [emailToVerify, setEmailToVerify] = useState('');
	const [otpValues, setOtpValues] = useState(Array(6).fill(''));
	const otpInputsRef = useRef([]);
	const [otpError, setOtpError] = useState('');
	const [otpSubmitting, setOtpSubmitting] = useState(false);
	const [resendCooldown, setResendCooldown] = useState(0);
	const [userClickedButton, setUserClickedButton] = useState({
		planId: null,
		isTrialButton: false,
	});
	const [copiedUrl, setCopiedUrl] = useState('');
	const [autoSelectedSavedCalled, setAutoSelectedSavedCalled] = useState(false);

	useEffect(() => {
		let timer;
		if (resendCooldown > 0) {
			timer = setInterval(() => setResendCooldown((s) => Math.max(0, s - 1)), 1000);
		}
		return () => clearInterval(timer);
	}, [resendCooldown]);
	const [showRestoreAlert, setShowRestoreAlert] = useState(false);
	const [restoreAlertKey, setRestoreAlertKey] = useState(Date.now());
	const [loadalert, setLoadalert] = useState(false);
	const [pendingEmailVerify, setPendingEmailVerify] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');
	const [hasRestored, setHasRestored] = useState(false);
	useEffect(() => {
		try {
			if (!saved || !saved.paymentMethod) {
				setPaymentMethod('bank');
			}
		} catch (e) {}
	}, []);
	useEffect(() => {
		if (step === 4) {
			try {
				if (!paymentMethod) setPaymentMethod('bank');
			} catch (e) {}
		}
	}, [step]);
	const navigate = useNavigate && useNavigate();
	const { darkModeStatus, setDarkModeStatus, themeStatus } = useDarkMode();
	const { t } = useTranslation();
	const { i18n } = useTranslation();
	const [phoneKey, setPhoneKey] = useState(0);
	const [phoneValues, setPhoneValues] = useState({
		contactNumber: businessInfo.contactNumber || '',
		whatsappNumber: businessInfo.whatsappNumber || '',
	});
	useEffect(() => {
		setPhoneValues({
			contactNumber: businessInfo.contactNumber || '',
			whatsappNumber: businessInfo.whatsappNumber || '',
		});
	}, [businessInfo.contactNumber, businessInfo.whatsappNumber]);
	const handlePhoneChange = (val, country, field) => {
		setPhoneValues((prev) => ({
			...prev,
			[field]: val,
		}));
		const processedValue = processPhoneNumber(val, country);
		setBusinessInfo((prev) => ({
			...prev,
			[field]: processedValue,
		}));
		if (errors[field]) {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[field];
				return newErrors;
			});
		}
	};
	useEffect(() => {
		let mounted = true;
		const tryAutoSave = async () => {
			if (!selectedPlan) return;
			if (autoSelectedSavedCalled) return;
			const isPreselected = userClickedButton?.planId === selectedPlan.id;
			if (!isPreselected) return;
			const isTrial = !!userClickedButton?.isTrialButton;
			const ok = await handleSelectPackage(selectedPlan, isTrial);
			if (mounted && ok) setAutoSelectedSavedCalled(true);
		};

		tryAutoSave();
		return () => (mounted = false);
	}, [selectedPlan, userClickedButton, autoSelectedSavedCalled]);
	const processPhoneNumber = (val, country) => {
		if (!val || val.trim().length === 0) {
			return '';
		}
		let cleaned = val.replace(/\s/g, '');
		const dialCode = country?.dialCode || '';
		if (dialCode === '94') {
			let local = cleaned.replace(/^\+?94/, '');
			if (local.startsWith('0')) {
				local = local.slice(1);
			}
			if (local.length === 9 && /^\d{9}$/.test(local)) {
				return `+94${local}`;
			} else {
				return cleaned.startsWith('+') ? cleaned : `+${cleaned}`;
			}
		}
		return cleaned.startsWith('+') ? cleaned : `+${cleaned}`;
	};
	const [planesData, setPlanesData] = useState([]);
	useEffect(() => {
		try {
			if (!selectedPlan || !Array.isArray(planesData) || planesData.length === 0) return;
			if (userClickedButton?.planId === selectedPlan.id) return;

			const planObj = planesData.find((p) => p.id === selectedPlan.id);
			if (!planObj) return;

			const rawPrice = planObj.package_price ?? planObj.price ?? 0;
			const num = parseFloat(rawPrice) || 0;
			const isFree =
				num === 0 ||
				planObj.is_free === true ||
				planObj.free === true ||
				String(planObj.package_name || '')
					.toLowerCase()
					.includes('free');
			setUserClickedButton({ planId: selectedPlan.id, isTrialButton: !isFree });
			setAutoSelectedSavedCalled(true);
		} catch (e) {}
	}, [selectedPlan, planesData]);
	const [pressedPlan, setPressedPlan] = useState(null);
	const [planSubmitting, setPlanSubmitting] = useState(false);
	const gridScrollRef = useRef(null);
	const topScrollRef = useRef(null);
	const scrollSyncEnabledRef = useRef(false);
	const [reviewLoading, setReviewLoading] = useState(false);
	const [getreview, setGetreview] = useState({});
	const [getreviewplan, setGetreviewplan] = useState({});
	const [reviewFetchError, setReviewFetchError] = useState('');
	const [ipCountryCode, setIpCountryCode] = useState('');
	const [ipCountryLoading, setIpCountryLoading] = useState(false);
	const [ipCountryError, setIpCountryError] = useState('');
	const showUSDPlansPrice =
		step === 2 &&
		(ipCountryCode || '').toUpperCase() !== '' &&
		(ipCountryCode || '').toUpperCase() !== 'LK';
	useEffect(() => {
		try {
			const urls = (localBankReceipt || [])
				.filter((p) => p && (p.uploaded || p.uploadedUrl))
				.map((p) => p.uploadedUrl || p.url)
				.filter(Boolean);
			setBankReceipt(urls);
		} catch (e) {}
	}, [localBankReceipt]);
	useEffect(() => {
		if (step !== 4) {
			setBillingPeriod('monthly');
			setBankReceipt([]);
			setLocalBankReceipt([]);
			setBankInputKey(Date.now());
		}
	}, [step]);

	useEffect(() => {
		const stateToSave = {
			step,
			businessInfo,
			selectedPlan,
			domainOption,
			customDomains,
			tempDomains,
			reviewAccepted,
			termsAccepted,
			paymentOption,
			bankReceipt,
			billingPeriod,
			paymentMethod,
			localBankReceipt,
		};
		try {
			localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(stateToSave));
		} catch {}
	}, [
		step,
		businessInfo,
		selectedPlan,
		domainOption,
		customDomains,
		tempDomains,
		reviewAccepted,
		termsAccepted,
		paymentOption,
		bankReceipt,
		billingPeriod,
		paymentMethod,
		localBankReceipt,
	]);
	useEffect(() => {
		let mounted = true;
		const fetchSettings = async () => {
			try {
				const payload = { action: 'get_onboard_settings' };
				const resp = await apiServicewt(payload, navigate);
				if (!mounted) return;
				if (resp && resp.type === 'success') {
					if (resp.country_list) {
						setCountryList(
							Object.entries(resp.country_list).map(([code, name]) => ({
								code,
								name,
							})),
						);
						setCountryPhoneCode(resp.country_phone_code || {});
					}
					if (resp.currency_list) {
						setCurrencies(resp.currency_list);
					}
					if (resp['Business Types']) {
						setBusinessTypes(resp['Business Types']);
					}
				} else {
					setMsgLoadalert(resp?.message || 'Failed to load settings');
					setMsgtypeLoadalert(resp?.type || 'error');
					startmodel();
				}
			} catch (err) {
				console.error('Failed to fetch onboarding settings', err);
				setMsgLoadalert(err?.message || 'Failed to fetch onboarding settings');
				setMsgtypeLoadalert('error');
				startmodel();
			}
		};
		fetchSettings();
		return () => {
			mounted = false;
		};
	}, [navigate]);
	useEffect(() => {
		let active = true;
		const detectCountry = async () => {
			setIpCountryLoading(true);
			setIpCountryError('');
			try {
				const resp = await fetch('https://ipapi.co/json/');
				if (!resp.ok) throw new Error('Failed to detect country');
				const data = await resp.json();
				if (!active) return;
				setIpCountryCode((data?.country_code || data?.country || '').toString());
			} catch (e) {
				if (!active) return;
				setIpCountryError(e?.message || 'Country detection failed');
			} finally {
				if (active) setIpCountryLoading(false);
			}
		};

		detectCountry();
		return () => {
			active = false;
		};
	}, []);

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
			document.documentElement.setAttribute('theme', storedTheme);
		}
	}, []);

	useEffect(() => {
		const currentLang = getLangWithKey(i18n.language);

		if (!currentLang) {
			i18n.changeLanguage(LANG.EN.lng);
		}
	}, []);

	useEffect(() => {
		try {
			const reachedPayment = localStorage.getItem('onboarding-reached-payment') === 'true';
			if (reachedPayment && step < 4) {
				setStep(4);
			}
		} catch {}
	}, []);

	useEffect(() => {
		try {
			if (step === 4) {
				localStorage.setItem('onboarding-reached-payment', 'true');
			} else if (step === 0) {
				localStorage.removeItem('onboarding-reached-payment');
			}
		} catch {}
	}, [step]);

	useEffect(() => {
		const fetchata = async () => {
			try {
				const item = { action: 'get_packages' };
				const flechdata = await apiServicewt(item, navigate);

				if (flechdata && (flechdata.type === 'Success' || flechdata.type === 'success')) {
					setPlanesData(flechdata.data);
					const urlParams = new URLSearchParams(window.location.search);
					const planId = urlParams.get('plan_id');
					const trial = urlParams.get('trial');
					if (planId !== null && flechdata.data && flechdata.data.length > 0) {
						const selectedPlanFromUrl = flechdata.data.find(
							(plan) => plan.id == planId,
						);
						if (selectedPlanFromUrl) {
							setSelectedPlan(selectedPlanFromUrl);
							setUserClickedButton({
								planId: selectedPlanFromUrl.id,
								isTrialButton: trial === 'yes',
							});
							if (trial === 'yes') {
								setTimeout(() => {
									setStep((s) => s + 1);
								}, 100);
							}
						}
					}
				} else {
					setPlanesData([]);
				}
			} catch (error) {
				setPlanesData([]);
			}
		};
		fetchata();
	}, []);
	useEffect(() => {
		const grid = gridScrollRef.current;
		const top = topScrollRef.current;
		if (!grid || !top) return;
		let isSyncing = false;

		const onGridScroll = () => {
			if (isSyncing) return;
			isSyncing = true;
			try {
				top.scrollLeft = grid.scrollLeft;
			} finally {
				isSyncing = false;
			}
		};

		const onTopScroll = () => {
			if (isSyncing) return;
			isSyncing = true;
			try {
				grid.scrollLeft = top.scrollLeft;
			} finally {
				isSyncing = false;
			}
		};

		const updateSpacer = () => {
			const spacer = top.querySelector('.scroll-spacer');
			if (spacer) spacer.style.width = grid.scrollWidth + 'px';
			const scrollWrap = grid.closest('.onboarding-card-scroll-wrap');
			if (scrollWrap) {
				const isVScrollable = scrollWrap.scrollHeight > scrollWrap.clientHeight + 1;
				const isHScrollable = grid.scrollWidth > grid.clientWidth + 1;
				scrollWrap.dataset.scroll = isVScrollable ? '1' : '0';
				scrollWrap.dataset.hscroll = isHScrollable ? '1' : '0';
			}
			const enabled = window.innerWidth > 700;
			scrollSyncEnabledRef.current = enabled;
			top.style.display = enabled ? 'block' : 'none';
			if (enabled) {
				grid.style.overflowX = 'auto';
			} else {
				grid.style.overflowX = '';
				grid.scrollLeft = 0;
				top.scrollLeft = 0;
			}
		};

		updateSpacer();
		grid.addEventListener('scroll', onGridScroll);
		top.addEventListener('scroll', onTopScroll);
		window.addEventListener('resize', updateSpacer);

		const mo = new MutationObserver(updateSpacer);
		mo.observe(grid, { childList: true, subtree: true });

		return () => {
			grid.removeEventListener('scroll', onGridScroll);
			top.removeEventListener('scroll', onTopScroll);
			window.removeEventListener('resize', updateSpacer);
			mo.disconnect();
		};
	}, [planesData, step]);

	useEffect(() => {
		const fetchReview = async () => {
			setReviewLoading(true);
			setReviewFetchError('');
			try {
				const email = (businessInfo?.email || '').trim();
				if (!email) {
					setGetreview({});
					setGetreviewplan({});
					setReviewFetchError(
						'Please enter your business email on the Business Info step to load review information.',
					);
					setReviewLoading(false);
					return;
				}

				const item = { action: 'get_review_info', email };
				const flechdata = await apiServicewt(item, navigate);

				if (flechdata && (flechdata.type === 'Success' || flechdata.type === 'success')) {
					if (
						flechdata.is_email_verified === false ||
						flechdata.is_email_verified === 'false'
					) {
						setGetreview({});
						setGetreviewplan({});
						setReviewFetchError(
							'The provided email is not verified. Please verify the email on the Business Info step before continuing.',
						);
					} else {
						setGetreview(flechdata.data || {});
						setGetreviewplan(flechdata.data?.package_details || {});
						setReviewFetchError('');
					}
				} else {
					setGetreview({});
					setGetreviewplan({});
					setReviewFetchError(flechdata?.message || 'Failed to load review information.');
				}
			} catch (error) {
				setGetreview({});
				setGetreviewplan({});
				setReviewFetchError('Failed to load review information. Please try again.');
			} finally {
				setReviewLoading(false);
			}
		};

		if (step === 3 || step === 4) fetchReview();
	}, [step, businessInfo?.email]);

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
		);
	};

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const renderWelcome = () => (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: 'calc(80vh - 80px)',
				minHeight: 400,
				textAlign: 'center',
			}}>
			<Logo width={200} />
			<h1 style={{ fontWeight: 700, marginBottom: 8, marginTop: 16 }}>
				Welcome to Business Setup
			</h1>
			<div style={{ color: '#666', fontSize: '1.5rem', marginBottom: 32 }}>
				Let’s get your business up and running in just a few easy steps.
				<br />
				Please follow the guided setup below.
			</div>
			<button className='onboarding-btn' onClick={() => setStep(1)}>
				Start Setup
			</button>
		</div>
	);
	const StepHeader = ({
		title,
		backLabel = 'Previous Step',
		nextLabel = 'Next',
		onBack,
		onNext,
		disableBack = false,
		disableNext = false,
		hideNext = false,
		showHelper = false,
		subtitle = null,
	}) => {
		const bg = themeStatus === 'dark' ? '#151724' : '#fff';
		const border = themeStatus === 'dark' ? '1px solid #2b2f46' : '1px solid #e6eefc';
		const titleColor = themeStatus === 'dark' ? '#fff' : '#1f2937';
		const subColor = themeStatus === 'dark' ? '#aab3d6' : '#5b6b9a';

		return (
			<section
				aria-label={title}
				style={{
					width: '100%',
					background: bg,
					border,
					borderRadius: 10,
					padding: '12px 16px',
					boxShadow: themeStatus === 'dark' ? '0 4px 18px #0008' : '0 6px 18px #dfeaff',
					marginBottom: 18,
					position: 'relative',
				}}>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					{onBack && (
						<button
							type='button'
							className='onboarding-btn'
							onClick={onBack}
							disabled={disableBack}
							style={{
								position: 'absolute',
								left: 12,
								padding: '8px 16px',
								marginLeft: 0,
								marginTop: 0,
								opacity: disableBack ? 0.6 : 1,
								borderRadius: 8,
								minWidth: 110,
								height: 40,
								display: 'inline-flex',
								alignItems: 'center',
								justifyContent: 'center',
								fontWeight: 700,
								background: 'transparent',
								color: '#4d69fa',
								border: '2px solid #4d69fa',
								boxShadow:
									themeStatus === 'dark'
										? '0 2px 8px #0006'
										: '0 4px 12px #00000011',
								cursor: disableBack ? 'not-allowed' : 'pointer',
								transition: 'transform 0.12s ease, box-shadow 0.12s ease',
							}}
							onMouseEnter={(e) =>
								!disableBack &&
								(e.currentTarget.style.transform = 'translateY(-2px)')
							}
							onMouseLeave={(e) => (e.currentTarget.style.transform = 'none')}>
							{backLabel}
						</button>
					)}

					<div style={{ textAlign: 'center' }}>
						<h2 style={{ margin: 0, fontWeight: 800, color: titleColor }}>{title}</h2>
						{(subtitle || showHelper) && (
							<div style={{ fontSize: 13, color: subColor, marginTop: 6 }}>
								{subtitle || 'Please complete the information below to continue.'}
							</div>
						)}
					</div>

					{onNext &&
						!hideNext &&
						(() => {
							const nextDisabled = disableNext || salonNameChecking;
							return (
								<button
									type='button'
									className='onboarding-btn'
									onClick={onNext}
									disabled={nextDisabled}
									style={{
										position: 'absolute',
										right: 12,
										padding: '8px 18px',
										marginRight: 0,
										marginTop: 0,
										opacity: nextDisabled ? 0.6 : 1,
										borderRadius: 8,
										minWidth: 140,
										height: 40,
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										fontWeight: 700,
										background: '#4d69fa',
										color: '#fff',
										border: 'none',
										boxShadow: '0 8px 24px #4d69fa22',
										cursor: nextDisabled ? 'not-allowed' : 'pointer',
										transition: 'transform 0.12s ease, box-shadow 0.12s ease',
									}}
									onMouseEnter={(e) =>
										!nextDisabled &&
										(e.currentTarget.style.transform = 'translateY(-2px)')
									}
									onMouseLeave={(e) =>
										(e.currentTarget.style.transform = 'none')
									}>
									{nextLabel}
								</button>
							);
						})()}
				</div>
			</section>
		);
	};
	const [businessTypes, setBusinessTypes] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [currencies, setCurrencies] = useState([]);
	const [countryPhoneCode, setCountryPhoneCode] = useState({});
	const languages = ['English', 'Sinhala', 'Tamil', 'French', 'German'];
	const daysOfWeek = [
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
		'Sunday',
	];
	const defaultPhoneIso = (() => {
		try {
			const codes = Object.values(countryPhoneCode || {}).map((v) =>
				String(v || '').replace('+', ''),
			);
			return codes.includes('94') ? 'lk' : undefined;
		} catch (e) {
			return undefined;
		}
	})();
	const getCountryName = (code) => {
		if (!code) return '';
		const found = countryList.find((c) => c.code === code);
		return found ? found.name : code;
	};

	const handleBusinessInfoChange = (e) => {
		const { name, value } = e.target;
		setBusinessInfo((prev) => {
			if (name === 'businessType') {
				return {
					...prev,
					businessType: value,
					businessTypeOther: value === 'Other' ? prev.businessTypeOther : '',
				};
			}
			if (name === 'salonName') {
				const next = { ...prev, salonName: value };
				if (!slugEditedRef.current) {
					next.projectSlug = slugify(value);
				}
				return next;
			}
			if (name === 'projectSlug') {
				slugEditedRef.current = true;
				return { ...prev, projectSlug: value };
			}
			return { ...prev, [name]: value };
		});
		setErrors((prev) => {
			if (!prev) return prev;
			const next = { ...prev };
			if (next[name]) delete next[name];
			if (name === 'salonName' && next.salonName) delete next.salonName;
			if (name === 'projectSlug' && next.projectSlug) delete next.projectSlug;
			return next;
		});
		if (name === 'salonName') {
			setSalonNameValid(false);
			setSalonNameError('');
			if (!slugEditedRef.current) {
				const nextSlug = slugify(value);
				setProjectSlugValid(false);
				setProjectSlugError('');
				if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
				debounceTimerRef.current = setTimeout(() => {
					if (nextSlug && nextSlug.length >= 2 && nextSlug !== projectSlugLastChecked) {
						doValidateProjectSlug(nextSlug);
					}
				}, 700);
			}
		}
		if (name === 'projectSlug') {
			setProjectSlugValid(false);
			setProjectSlugError('');
			if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
			debounceTimerRef.current = setTimeout(() => {
				const trimmed = String(value || '').trim();
				if (trimmed && trimmed.length >= 2 && trimmed !== projectSlugLastChecked) {
					doValidateProjectSlug(trimmed);
				}
			}, 700);
		}
	};
	const slugify = (s) =>
		String(s || '')
			.trim()
			.toLowerCase()
			.replace(/\s+/g, '-')
			.replace(/[^a-z0-9-]/g, '');
	const doValidateSalonName = async (name) => {
		return !!(name && String(name).trim().length >= 2);
	};

	const doValidateProjectSlug = async (slugRaw, force = false) => {
		const trimmed = String(slugRaw || '').trim();
		const normalized = slugify(trimmed);
		if (!trimmed || trimmed.length < 2) {
			setProjectSlugValid(false);
			setProjectSlugError('Slug must be at least 2 characters');
			setProjectSlugChecking(false);
			return false;
		}
		if (normalized !== trimmed) {
			setProjectSlugValid(false);
			setProjectSlugError('Use only lowercase letters, numbers, and hyphens');
			setProjectSlugChecking(false);
			return false;
		}
		if (/^-|-$/.test(normalized)) {
			setProjectSlugValid(false);
			setProjectSlugError('Slug can’t start or end with a hyphen');
			setProjectSlugChecking(false);
			return false;
		}
		if (!force && normalized === projectSlugLastChecked) return;

		const mySeq = ++validationSeqRef.current;
		setProjectSlugChecking(true);
		setProjectSlugError('');
		try {
			if (lastRequestedSlugRef.current === normalized && projectSlugChecking) {
				return;
			}
			lastRequestedSlugRef.current = normalized;
			const payload = { action: 'validate_site_urls', salon_name: normalized };
			const responce = await apiServicewt(payload, navigate);
			if (lastRequestedSlugRef.current === normalized) lastRequestedSlugRef.current = '';
			if (mySeq !== validationSeqRef.current) return;
			const ok = !!(
				responce &&
				responce.business_url &&
				responce.customer_url &&
				responce.employee_url
			);
			setProjectSlugChecking(false);
			setProjectSlugValid(ok);
			setProjectSlugLastChecked(normalized);
			if (!ok) {
				setProjectSlugError(responce?.message || responce?.error || 'Slug not available');
			} else {
				setProjectSlugError('');
			}
			return ok;
		} catch (err) {
			if (mySeq !== validationSeqRef.current) return;
			console.error('Project slug validation failed', err);
			setProjectSlugChecking(false);
			setProjectSlugValid(false);
			setProjectSlugError('Validation failed. Please try again.');
			setMsgLoadalert(err?.message || 'Validation request failed');
			setMsgtypeLoadalert('error');
			startmodel();
			return false;
		}
	};
	const resendVerificationCode = async () => {
		if (!emailToVerify) return;
		try {
			setResendCooldown(30);
			const payload = { action: 'resend_code', email: emailToVerify };
			const resp = await apiServicewt(payload, navigate);
			if (resp && resp.type === 'success') {
				setMsgLoadalert(resp.message || 'Verification code resent');
				setMsgtypeLoadalert('success');
				startmodel();
			} else {
				setMsgLoadalert(resp?.message || 'Failed to resend code');
				setMsgtypeLoadalert(resp?.type || 'error');
				startmodel();
			}
		} catch (err) {
			setMsgLoadalert(err?.message || 'Request failed');
			setMsgtypeLoadalert('error');
			startmodel();
		}
	};
	const verifyEmailOtpWithCode = async (code) => {
		const trimmed = String(code || '').trim();
		if (trimmed.length !== 6) {
			setOtpError('Please enter the 6-digit code');
			return false;
		}
		setOtpSubmitting(true);
		try {
			const payload = {
				action: 'verify_email',
				email: emailToVerify,
				verification_code: trimmed,
			};
			const resp = await apiServicewt(payload, navigate);
			setOtpSubmitting(false);
			if (resp && resp.type === 'success') {
				setEmailVerifyOpen(false);
				setOtpError('');
				setMsgLoadalert(resp.message || 'Email verified');
				setMsgtypeLoadalert('success');
				startmodel();
				setStep(2);
				return true;
			}
			setOtpError(resp?.message || 'Verification failed');
			return false;
		} catch (err) {
			setOtpSubmitting(false);
			setOtpError(err?.message || 'Request failed');
			return false;
		}
	};

	const verifyEmailOtp = async () => {
		const code = otpValues.join('').trim();
		return verifyEmailOtpWithCode(code);
	};

	const handleHoursChange = (idx, field, value) => {
		setBusinessInfo((prev) => ({
			...prev,
			hours: prev.hours.map((h, i) => (i === idx ? { ...h, [field]: value } : h)),
		}));
		setErrors((prev) => {
			if (!prev) return prev;
			const next = { ...prev };
			if (next.hoursOpen && typeof next.hoursOpen === 'object') {
				const eo = { ...next.hoursOpen };
				delete eo[idx];
				if (Object.keys(eo).length) next.hoursOpen = eo;
				else delete next.hoursOpen;
			}
			if (next.hoursClose && typeof next.hoursClose === 'object') {
				const ec = { ...next.hoursClose };
				delete ec[idx];
				if (Object.keys(ec).length) next.hoursClose = ec;
				else delete next.hoursClose;
			}
			if (next.hours) delete next.hours;
			return next;
		});
	};
	const startmodel = () => setLoadalert(true);
	const closemodel = () => {
		setLoadalert(false);
		if (pendingEmailVerify) {
			setPendingEmailVerify(false);
			setEmailVerifyOpen(true);
		}
	};

	const handleAddDay = () => {
		const usedDays = businessInfo.hours.map((h) => h.day);
		const nextDay = daysOfWeek.find((day) => !usedDays.includes(day));
		if (nextDay) {
			setBusinessInfo((prev) => {
				const prevHours = Array.isArray(prev.hours) ? prev.hours : [];
				const last = prevHours.length > 0 ? prevHours[prevHours.length - 1] : null;
				const newEntry =
					last && last.open && last.close
						? { day: nextDay, open: last.open, close: last.close }
						: { day: nextDay, open: '', close: '' };
				return {
					...prev,
					hours: [...prevHours, newEntry],
				};
			});
		}
	};

	const handleLogoChange = (type) => (e) => {
		const files = Array.from(e.target.files || []);
		if (!files.length) return;
		const allowedTypes = [
			'image/jpeg',
			'image/png',
			'image/gif',
			'image/webp',
			'image/bmp',
			'image/svg+xml',
		];
		const invalidFile = files.find((file) => !allowedTypes.includes(file.type));
		if (invalidFile) {
			setMsgLoadalert('Only image files are allowed.');
			setMsgtypeLoadalert('error');
			startmodel();
			return;
		}

		const file = files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setCropperImg(reader.result);
			setCropperImgFile(file);
			setCropperTarget(type);
			setCropperOpen(true);
		};
		reader.readAsDataURL(file);
	};
	const { uploadImage } = CommonImageApiService();
	const compressImage = (src, maxWidth = 1600, maxHeight = 1600, quality = 0.8) =>
		new Promise((resolve, reject) => {
			try {
				const img = new Image();
				img.onload = () => {
					let { width, height } = img;
					const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
					const w = Math.round(width * ratio);
					const h = Math.round(height * ratio);
					const canvas = document.createElement('canvas');
					canvas.width = w;
					canvas.height = h;
					const ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0, w, h);
					canvas.toBlob(
						(blob) => {
							if (blob) resolve(blob);
							else reject(new Error('Failed to create blob'));
						},
						'image/jpeg',
						quality,
					);
				};
				img.onerror = (e) => reject(e || new Error('Image load error'));
				if (typeof src === 'string') {
					img.src = src;
				} else {
					const reader = new FileReader();
					reader.onload = (ev) => {
						img.src = ev.target.result;
					};
					reader.onerror = (e) => reject(e || new Error('File read error'));
					reader.readAsDataURL(src);
				}
			} catch (err) {
				reject(err);
			}
		});

	const handleCropperComplete = async (croppedImage, croppedFile) => {
		setCropperOpen(false);
		setBusinessInfo((prev) => ({
			...prev,
			[cropperTarget]: [
				{
					id: Date.now() + Math.random(),
					file: croppedImage,
					name: croppedFile.name,
					uploading: true,
				},
			],
		}));

		try {
			const formData = new FormData();
			let uploadBlob = null;
			let uploadFilename = (croppedFile && croppedFile.name) || 'upload.jpg';
			try {
				const compressed = await compressImage(croppedImage, 1600, 1600, 0.8);
				uploadBlob = compressed;
			} catch (compressErr) {
				uploadBlob = croppedFile;
			}
			try {
				const sizeBytes = uploadBlob && uploadBlob.size ? uploadBlob.size : 0;
				const human =
					sizeBytes < 1024
						? `${sizeBytes} B`
						: sizeBytes < 1024 * 1024
						? `${(sizeBytes / 1024).toFixed(1)} KB`
						: `${(sizeBytes / (1024 * 1024)).toFixed(2)} MB`;
				console.log(
					'[Onboarding] Uploading image:',
					uploadFilename,
					'size =',
					sizeBytes,
					'bytes (',
					human,
					')',
				);
			} catch (e) {}

			formData.append('onboarding[0]', uploadBlob, uploadFilename);
			formData.append('salon_name', businessInfo.salonName);

			const resp = await uploadImage({ formData });
			const data = resp && resp.data ? resp.data : null;
			if (
				data &&
				typeof data.type === 'string' &&
				data.type.toLowerCase() === 'success' &&
				data.url
			) {
				const uploadedUrl = data.url;
				setBusinessInfo((prev) => ({
					...prev,
					[cropperTarget]: [
						{
							id: Date.now() + Math.random(),
							file: uploadedUrl,
							name: croppedFile.name,
						},
					],
				}));
				setErrors((prev) => {
					if (!prev) return prev;
					const next = { ...prev };
					if (next[cropperTarget]) delete next[cropperTarget];
					return next;
				});
			} else {
				setMsgLoadalert((data && data.message) || 'Image upload failed');
				setMsgtypeLoadalert((data && data.type) || 'error');
				startmodel();
				setBusinessInfo((prev) => ({ ...prev, [cropperTarget]: [] }));
				setErrors((prev) => ({ ...prev, [cropperTarget]: 'Image upload failed' }));
			}
		} catch (err) {
			setMsgLoadalert(err?.message || 'Image upload failed');
			setMsgtypeLoadalert('error');
			startmodel();
			setBusinessInfo((prev) => ({ ...prev, [cropperTarget]: [] }));
			setErrors((prev) => ({ ...prev, [cropperTarget]: 'Image upload failed' }));
		} finally {
			setCropperImg(null);
			setCropperImgFile(null);
			setCropperTarget(null);
		}
	};

	const handleDeleteDay = (idx) => {
		setBusinessInfo((prev) => ({
			...prev,
			hours: prev.hours.filter((_, i) => i !== idx),
		}));
	};

	const TEMP_DOMAIN_SUFFIX = 'schedulerdesk.com';
	const [domainStep, setDomainStep] = useState('intro');
	const [tempGenLoading, setTempGenLoading] = useState(false);
	const [tempGenDomains, setTempGenDomains] = useState(null);
	const [tempGenStatus, setTempGenStatus] = useState(null);
	const [tempGenError, setTempGenError] = useState(null);
	const [customStatus, setCustomStatus] = useState({});
	const [showDnsHelp, setShowDnsHelp] = useState(false);

	const generateTempDomains = () => {
		setTempGenLoading(true);
		setTempGenError(null);
		const brand = 'tempbrand' + Math.floor(Math.random() * 1000);
		const domains = {};
		Object.keys(tempDomains).forEach((key) => {
			domains[key] = `${key}.${brand}.${TEMP_DOMAIN_SUFFIX}`;
		});
		setTimeout(() => {
			setTempGenDomains(domains);
			setTempGenStatus(Object.fromEntries(Object.keys(domains).map((k) => [k, 'loading'])));
			setTimeout(() => {
				const status = {};
				Object.keys(domains).forEach((k) => {
					status[k] = 'success';
				});
				setTempGenStatus(status);
				setTempGenLoading(false);
				if (Object.values(status).includes('fail')) {
					setTempGenError('Some domains failed validation. Please re-generate.');
				}
			}, 1200);
		}, 1000);
	};

	const validateCustomDomain = (key) => {
		setCustomStatus((prev) => ({ ...prev, [key]: 'loading' }));
		setTimeout(() => {
			setCustomStatus((prev) => ({
				...prev,
				[key]: Math.random() > 0.2 ? 'success' : 'fail',
			}));
		}, 1200);
	};

	const validateAllCustomDomains = () => {
		Object.keys(customDomains).forEach((key) => {
			if (customDomains[key]) validateCustomDomain(key);
		});
	};

	const allTempValid =
		tempGenStatus && Object.values(tempGenStatus).every((s) => s === 'success');
	const allCustomValid =
		Object.keys(customDomains).length > 0 &&
		Object.keys(customDomains).every((key) => customStatus[key] === 'success');

	const renderDomainIntro = () => {
		const getCardStyle = (selected, type) => {
			if (themeStatus === 'dark') {
				return {
					minWidth: 220,
					maxWidth: 260,
					background: selected ? '#23263a' : '#181a25',
					border: selected ? '2px solid #4d69fa' : '2px solid #23263a',
					cursor: 'pointer',
					boxShadow: selected ? '0 4px 24px #4d69fa22' : undefined,
					transition: 'box-shadow 0.2s, border 0.2s',
				};
			} else {
				return {
					minWidth: 220,
					maxWidth: 260,
					background: selected ? '#eaf0ff' : '#f8f9fa',
					border: selected ? '2px solid #4d69fa' : '2px solid #eee',
					cursor: 'pointer',
					boxShadow: selected ? '0 4px 24px #4d69fa22' : undefined,
					transition: 'box-shadow 0.2s, border 0.2s',
				};
			}
		};
		useEffect(() => {
			if (step !== 4) {
				setBillingPeriod('monthly');
			}
		}, [step]);

		const getTitleColor = () => (themeStatus === 'dark' ? '#fff' : '#23263a');
		return (
			<div
				style={{
					maxWidth: '100%',
					margin: '0 auto',
					textAlign: 'center',
					minHeight: '65vh',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100%',
				}}>
				<StepHeader
					title='Point Your Domain'
					subtitle='Choose how you want to set up your domain.'
					backLabel='Previous Step'
					nextLabel='Continue'
					onBack={() => setStep(2)}
					onNext={() => {
						if (domainOption === 'temporary') setDomainStep('temp');
						else if (domainOption === 'custom') setDomainStep('custom');
					}}
					disableNext={!domainOption}
				/>
				<div style={{ fontSize: 18, color: '#4d69fa', marginBottom: 8, fontWeight: 600 }}>
					Choose how you want to set up your domain.
				</div>
				<div style={{ color: '#888', marginBottom: 32, fontSize: 16 }}>
					You can use your own domain or proceed with a temporary one now and connect your
					domain later.
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						gap: 32,
						marginBottom: 32,
					}}>
					<div
						className={`onboarding-card${
							domainOption === 'temporary' ? ' selected' : ''
						}`}
						style={getCardStyle(domainOption === 'temporary', 'temporary')}
						onClick={() => setDomainOption('temporary')}>
						<div
							style={{
								fontWeight: 700,
								fontSize: 20,
								marginBottom: 8,
								color: getTitleColor(),
							}}>
							Use Temporary Domain
						</div>
						<div style={{ color: '#888', fontSize: 15 }}>
							Get started instantly with a free temporary domain. You can connect your
							own later.
						</div>
					</div>
					<div
						className={`onboarding-card${domainOption === 'custom' ? ' selected' : ''}`}
						style={getCardStyle(domainOption === 'custom', 'custom')}
						onClick={() => setDomainOption('custom')}>
						<div
							style={{
								fontWeight: 700,
								fontSize: 20,
								marginBottom: 8,
								color: getTitleColor(),
							}}>
							Use Custom Domain
						</div>
						<div style={{ color: '#888', fontSize: 15 }}>
							Already have a domain? Connect it now for a branded experience.
						</div>
					</div>
				</div>
				<div
					className='onboarding-bottom-nav'
					style={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 16 }}>
					<button
						type='button'
						className='onboarding-btn'
						style={{ background: '#aaa', minWidth: 120 }}
						onClick={() => setStep(2)}>
						Back
					</button>
					<button
						type='button'
						className='onboarding-btn'
						style={{ minWidth: 120 }}
						disabled={!domainOption}
						onClick={() => {
							if (domainOption === 'temporary') setDomainStep('temp');
							else if (domainOption === 'custom') setDomainStep('custom');
						}}>
						Continue
					</button>
				</div>
			</div>
		);
	};

	const renderTempDomainFlow = () => (
		<div
			style={{
				maxWidth: '100%',
				margin: '0 auto',
				minHeight: '65vh',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
			}}>
			<StepHeader
				title='Use Temporary Domain'
				subtitle='We’ll generate temporary sub-domains for you to get started.'
				backLabel='Previous Step'
				nextLabel={
					tempGenDomains
						? allTempValid
							? 'Proceed to Next Step'
							: 'Re-generate Domains'
						: tempGenLoading
						? 'Generating...'
						: 'Generate Temporary Domains'
				}
				onBack={() => setDomainStep('intro')}
				onNext={() => {
					if (!tempGenDomains) generateTempDomains();
					else if (allTempValid) setStep(4);
					else generateTempDomains();
				}}
				disableNext={tempGenDomains ? !allTempValid : false}
			/>
			<div
				style={{
					color: '#4d69fa',
					textAlign: 'center',
					marginBottom: 24,
					fontWeight: 600,
					fontSize: 16,
				}}>
				We’ll generate temporary sub-domains for you to get started immediately.
				<br />
				<span style={{ color: '#888', fontWeight: 400 }}>
					You can connect your own domain anytime later.
				</span>
			</div>
			{!tempGenDomains ? (
				<>
					<div style={{ textAlign: 'center', marginBottom: 32 }}>
						<button
							type='button'
							className='onboarding-btn'
							style={{ minWidth: 220, fontWeight: 600 }}
							onClick={generateTempDomains}
							disabled={tempGenLoading}>
							{tempGenLoading ? 'Generating...' : 'Generate Temporary Domains'}
						</button>
					</div>
					<div
						className='onboarding-bottom-nav'
						style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
						<button
							type='button'
							className='onboarding-btn'
							style={{ background: '#aaa', minWidth: 120 }}
							onClick={() => setDomainStep('intro')}>
							Back
						</button>
					</div>
				</>
			) : (
				<>
					<div style={{ marginBottom: 16, fontWeight: 600 }}>Generated Domains:</div>
					<div style={{ marginBottom: 16 }}>
						{Object.keys(tempGenDomains).map((key) => (
							<div
								key={key}
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 12,
									marginBottom: 8,
								}}>
								<span
									style={{
										width: 120,
										fontWeight: 500,
										textTransform: 'capitalize',
										color: '#4d69fa',
									}}>
									{key}:
								</span>
								<span style={{ fontFamily: 'monospace', fontSize: 15 }}>
									{tempGenDomains[key]}
								</span>
								{tempGenStatus && tempGenStatus[key] === 'loading' && (
									<span style={{ color: '#888' }}>
										<span className='spinner-border spinner-border-sm' />{' '}
										Validating...
									</span>
								)}
								{tempGenStatus && tempGenStatus[key] === 'success' && (
									<span style={{ color: 'green', fontWeight: 600 }}>
										✅ Validated
									</span>
								)}
								{tempGenStatus && tempGenStatus[key] === 'fail' && (
									<span style={{ color: 'red', fontWeight: 600 }}>❌ Failed</span>
								)}
							</div>
						))}
					</div>
					{tempGenLoading && (
						<div style={{ color: '#888', marginBottom: 12 }}>Validating domains...</div>
					)}
					{allTempValid && (
						<div style={{ color: 'green', fontWeight: 600, marginBottom: 16 }}>
							<span style={{ fontSize: 18 }}>✅ Validation successful!</span>
						</div>
					)}
					{tempGenError && (
						<div style={{ color: 'red', marginBottom: 16 }}>{tempGenError}</div>
					)}
					<div
						className='onboarding-bottom-nav'
						style={{
							display: 'flex',
							justifyContent: 'center',
							width: '100%',
							marginTop: 24,
						}}>
						<button
							type='button'
							className='onboarding-btn'
							style={{ background: '#aaa', minWidth: 120, marginRight: 12 }}
							onClick={() => {
								setTempGenDomains(null);
								setTempGenStatus(null);
								setDomainStep('intro');
							}}>
							Back
						</button>
						{!allTempValid && (
							<button
								type='button'
								className='onboarding-btn'
								onClick={generateTempDomains}
								style={{ marginRight: 12 }}>
								Re-generate Domains
							</button>
						)}
						<button
							type='button'
							className='onboarding-btn'
							disabled={!allTempValid}
							onClick={() => setStep(4)}>
							Proceed to Next Step
						</button>
					</div>
				</>
			)}
		</div>
	);

	const renderCustomDomainFlow = () => (
		<div
			style={{
				maxWidth: '100%',
				margin: '0 auto',
				minHeight: '60vh',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
			}}>
			<StepHeader
				title='Use Your Own Domain'
				subtitle='Enter your domain below and we’ll help you configure DNS records.'
				backLabel='Previous Step'
				nextLabel='Proceed to Next Step'
				onBack={() => {
					setCustomStatus({});
					setDomainStep('intro');
				}}
				onNext={() => setStep(4)}
				disableNext={!allCustomValid}
			/>
			<div style={{ color: '#888', textAlign: 'center', marginBottom: 18 }}>
				Enter your domain below. We’ll help you point the required sub-domains.
				<br />
				Make sure you’ve added the DNS records before validation.
			</div>
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr 2fr 120px 120px',
					gap: 12,
					maxWidth: '100%',
					margin: '0 auto',
					alignItems: 'center',
					marginBottom: 12,
				}}>
				<div style={{ fontWeight: 600 }}>Sub-Domain</div>
				<div style={{ fontWeight: 600 }}>Input</div>
				<div></div>
				<div></div>
				{Object.keys(customDomains).map((key) => (
					<React.Fragment key={key}>
						<div style={{ textTransform: 'capitalize', fontWeight: 500 }}>{key}</div>
						<input
							className='form-control mb-2 mt-2'
							name={key}
							value={customDomains[key]}
							onChange={(e) =>
								setCustomDomains((prev) => ({ ...prev, [key]: e.target.value }))
							}
							placeholder={`${key}.YOURDOMAIN.com`}
							style={{
								background: themeStatus === 'dark' ? '#23263a' : '#f8f9fa',
								color: themeStatus === 'dark' ? '#fff' : '#23263a',
							}}
						/>
						<button
							type='button'
							className='onboarding-btn'
							style={{ fontSize: 14, padding: '4px 10px', margin: 0 }}
							onClick={() => validateCustomDomain(key)}
							disabled={!customDomains[key] || customStatus[key] === 'loading'}>
							{customStatus[key] === 'loading' ? 'Validating...' : 'Validate'}
						</button>
						<div>
							{customStatus[key] === 'success' && (
								<span style={{ color: 'green', fontWeight: 600 }}>✅ Valid</span>
							)}
							{customStatus[key] === 'fail' && (
								<span style={{ color: 'red', fontWeight: 600 }}>❌ Not found</span>
							)}
						</div>
					</React.Fragment>
				))}
			</div>
			<div
				className='onboarding-bottom-nav'
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					gap: 12,
					marginBottom: 12,
					width: '100%',
				}}>
				<button
					type='button'
					className='onboarding-btn'
					style={{ fontSize: 14 }}
					onClick={validateAllCustomDomains}>
					Check all at once
				</button>
				<button
					type='button'
					className='onboarding-btn'
					style={{ fontSize: 14 }}
					onClick={() => setShowDnsHelp((v) => !v)}>
					{showDnsHelp ? 'Hide DNS Setup Help' : 'Show DNS Setup Help'}
				</button>
			</div>
			{showDnsHelp && (
				<div
					style={{
						background: themeStatus === 'dark' ? '#23263a' : '#f8f9fa',
						border: themeStatus === 'dark' ? '1px solid #35395a' : '1px solid #eee',
						borderRadius: 8,
						padding: 18,
						marginBottom: 18,
						color: themeStatus === 'dark' ? '#fff' : '#23263a',
						width: '100%',
					}}>
					<div style={{ fontWeight: 600, marginBottom: 8 }}>DNS Setup Help</div>
					<div style={{ fontSize: 15, marginBottom: 6 }}>
						Add the following CNAME records in your DNS provider:
					</div>
					<table style={{ width: '100%', fontSize: 15, marginBottom: 8 }}>
						<thead>
							<tr
								style={{
									background: themeStatus === 'dark' ? '#181a25' : '#eaf0ff',
								}}>
								<th
									style={{
										padding: 4,
										textAlign: 'left',
										color: themeStatus === 'dark' ? '#fff' : '#23263a',
									}}>
									Subdomain
								</th>
								<th
									style={{
										padding: 4,
										textAlign: 'left',
										color: themeStatus === 'dark' ? '#fff' : '#23263a',
									}}>
									Type
								</th>
								<th
									style={{
										padding: 4,
										textAlign: 'left',
										color: themeStatus === 'dark' ? '#fff' : '#23263a',
									}}>
									Value
								</th>
							</tr>
						</thead>
						<tbody>
							{Object.keys(customDomains).map((key) => (
								<tr key={key}>
									<td style={{ padding: 4 }}>{key}.YOURDOMAIN.com</td>
									<td style={{ padding: 4 }}>CNAME</td>
									<td style={{ padding: 4 }}>{key}.schedulerdesk.com</td>
								</tr>
							))}
						</tbody>
					</table>
					<div style={{ fontSize: 14, color: themeStatus === 'dark' ? '#aaa' : '#888' }}>
						<b>Note:</b> DNS changes may take up to 24 hours to propagate.
					</div>
				</div>
			)}
			<div style={{ textAlign: 'right', marginTop: 24, width: '100%' }}>
				<button
					type='button'
					className='onboarding-btn'
					style={{ background: '#aaa', marginRight: 12 }}
					onClick={() => {
						setCustomStatus({});
						setDomainStep('intro');
					}}>
					Back
				</button>
				<button
					type='button'
					className='onboarding-btn'
					disabled={!allCustomValid}
					onClick={() => setStep(4)}>
					Proceed to Next Step
				</button>
			</div>
		</div>
	);

	const renderDomainSetup = () => {
		if (domainStep === 'intro') return renderDomainIntro();
		if (domainStep === 'temp') return renderTempDomainFlow();
		if (domainStep === 'custom') return renderCustomDomainFlow();
		return null;
	};

	const renderReview = () => {
		const summaryBg = themeStatus === 'dark' ? '#23263a' : '#f8f9fa';
		const summaryBorder = themeStatus === 'dark' ? '1px solid #35395a' : '2px solid #eee';
		const logoBoxStyle = {
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			border: summaryBorder,
			borderRadius: 8,
			padding: 6,
			width: 120,
			height: 60,
			overflow: 'hidden',
			background: 'transparent',
		};
		const logoImgStyle = { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' };
		const logoMobileBoxStyle = { ...logoBoxStyle, width: 60, height: 60 };
		const faviconBoxStyle = {
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: 48,
			height: 48,
			borderRadius: 8,
			border: summaryBorder,
			marginRight: 8,
			overflow: 'hidden',
		};
		const plan = getreviewplan;
		const countryDisplay = (() => {
			try {
				if (getreview?.country)
					return getCountryName(getreview.country) || getreview.country;
				return getCountryName(businessInfo.country) || businessInfo.country;
			} catch (e) {
				return businessInfo.country || '';
			}
		})();

		const contactDisplay = (() => {
			if (getreview?.contact_number) {
				const code = getreview.contact_number_code
					? `+${getreview.contact_number_code}`
					: '';
				return `${code}${code ? ' ' : ''}${getreview.contact_number}`.trim();
			}
			return businessInfo.contactNumber || '';
		})();

		const whatsappDisplay = (() => {
			if (getreview?.whatsapp_number) {
				const code = getreview.whatsapp_number_code
					? `+${getreview.whatsapp_number_code}`
					: '';
				return `${code}${code ? ' ' : ''}${getreview.whatsapp_number}`.trim();
			}
			return businessInfo.whatsappNumber || '';
		})();

		return (
			<div
				style={{
					maxWidth: '100%',
					margin: '0 auto',
					display: 'grid',
					gridTemplateColumns: reviewLoading ? '1fr' : '1fr 380px',
					gap: reviewFetchError ? 0 : 20,
					alignItems: 'start',
				}}>
				<div style={{ gridColumn: '1 / -1' }}>
					<StepHeader
						title='Review & Confirm'
						subtitle='Review all details before proceeding to confirmation.'
						backLabel='Previous Step'
						nextLabel='Proceed to Confirmation'
						onBack={() => setStep(2)}
						onNext={() => setStep(4)}
						disableNext={
							reviewLoading ||
							!(reviewAccepted && termsAccepted) ||
							(!!reviewFetchError &&
								String(reviewFetchError).toLowerCase().includes('not verified'))
						}
					/>
				</div>
				{reviewLoading ? (
					<div style={{ padding: 18, textAlign: 'center' }}>
						<div
							className='spinner-border'
							role='status'
							style={{ width: 36, height: 36, borderWidth: 3 }}>
							<span className='visually-hidden'>Loading review details...</span>
						</div>
						<div style={{ marginTop: 8 }}>Loading review details...</div>
					</div>
				) : reviewFetchError ? (
					<div style={{ gridColumn: '1 / -1' }}>
						<div
							style={{
								padding: 18,
								borderRadius: 12,
								border: summaryBorder,
								background: summaryBg,
								color: themeStatus === 'dark' ? '#fff' : '#1f2937',
								boxShadow:
									themeStatus === 'dark'
										? '0 6px 20px rgba(0,0,0,0.6)'
										: '0 10px 30px rgba(15,23,42,0.06)',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}>
							<div style={{ maxWidth: '70%' }}>
								<h4 style={{ marginTop: 0, marginBottom: 8 }}>
									Unable to load review
								</h4>
								<div
									style={{
										color: themeStatus === 'dark' ? '#bfc6d6' : '#556',
										fontSize: 14,
									}}>
									{reviewFetchError}
								</div>
							</div>
							<div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
								<button
									onClick={() => setStep(1)}
									className='onboarding-btn'
									style={{
										padding: '8px 16px',
										marginTop: 0,
									}}>
									Edit Business Info
								</button>
								{businessInfo?.email ? (
									<button
										onClick={() => {
											setEmailToVerify(businessInfo.email);
											setOtpValues(Array(6).fill(''));
											setOtpError('');
											setEmailVerifyOpen(true);
										}}
										className='onboarding-btn'
										style={{
											padding: '8px 16px',
											background: '#4d69fa',
											color: '#fff',
											marginTop: 0,
										}}>
										Verify Email
									</button>
								) : null}
							</div>
						</div>
					</div>
				) : (
					<>
						<div
							className='onboarding-summary review-card'
							style={{
								background: summaryBg,
								border: summaryBorder,
								padding: 18,
								borderRadius: 12,
								boxShadow:
									themeStatus === 'dark'
										? '0 6px 20px rgba(0,0,0,0.6)'
										: '0 10px 30px rgba(15,23,42,0.06)',
							}}>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}>
								<h4 style={{ margin: 0 }}>Business Information</h4>
								<button
									className='onboarding-btn'
									style={{ padding: '4px 18px', fontSize: 14, margin: 0 }}
									onClick={() => setStep(1)}>
									Edit
								</button>
							</div>

							<div
								style={{
									display: 'grid',
									gridTemplateColumns: '1fr 1fr',
									gap: 12,
									marginTop: 12,
								}}>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Salon Name
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.salon_name || businessInfo.salonName}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Owner / Manager
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.owner_name || businessInfo.ownerName}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Owner Last Name
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.owner_last_name || businessInfo.ownerLastName}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Address
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.business_address || businessInfo.address}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Address 2
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.business_address2 || businessInfo.address2}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Country
									</div>
									<div style={{ marginTop: 6 }}>{countryDisplay}</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										City
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.city || businessInfo.city}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
											State
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.state || businessInfo.state}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
											Postal Code (ZIP Code)
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.postal_code || businessInfo.postal_code}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Contact Number
									</div>
									<div style={{ marginTop: 6 }}>{contactDisplay}</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										WhatsApp
									</div>
									<div style={{ marginTop: 6 }}>
										{whatsappDisplay || (
											<span style={{ color: '#888' }}>Not provided</span>
										)}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Email
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.email || businessInfo.email}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										GST / Tax ID
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.gst_vat_tax_id || businessInfo.gstVatTaxId || (
											<span style={{ color: '#888' }}>Not provided</span>
										)}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Business Type
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.business_type ||
											(businessInfo.businessType === 'Other'
												? businessInfo.businessTypeOther
												: businessInfo.businessType)}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Currency
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.currency || businessInfo.currency}
									</div>
								</div>
								<div>
									<div
										style={{
											fontSize: 13,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
											fontWeight: 700,
										}}>
										Language
									</div>
									<div style={{ marginTop: 6 }}>
										{getreview.default_language || businessInfo.language}
									</div>
								</div>
							</div>

							{(getreview.business_sd_url ||
								getreview.customer_sd_url ||
								getreview.employee_sd_url) && (
								<div style={{ marginTop: 12 }}>
									<div
										style={{
											fontSize: 13,
											fontWeight: 700,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
										}}>
										Site URLs
									</div>
									<ul>
										{getreview.business_sd_url && (
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
												}}>
												<span>
													Business:{' '}
													<span style={{ fontFamily: 'monospace' }}>
														{getreview.business_sd_url}
													</span>
												</span>
												<span
													style={{
														fontSize: 12,
														color: '#4d69fa',
														cursor: 'pointer',
														marginLeft: 8,
													}}
													onClick={() => {
														navigator.clipboard &&
															navigator.clipboard.writeText(
																getreview.business_sd_url,
															);
														setCopiedUrl(getreview.business_sd_url);
														setTimeout(() => setCopiedUrl(''), 2000);
													}}>
													{copiedUrl === getreview.business_sd_url
														? 'Copied'
														: 'Copy'}
												</span>
											</li>
										)}
										{getreview.customer_sd_url && (
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
												}}>
												<span>
													Customer:{' '}
													<span style={{ fontFamily: 'monospace' }}>
														{getreview.customer_sd_url}
													</span>
												</span>
												<span
													style={{
														fontSize: 12,
														color: '#4d69fa',
														cursor: 'pointer',
														marginLeft: 8,
													}}
													onClick={() => {
														navigator.clipboard &&
															navigator.clipboard.writeText(
																getreview.customer_sd_url,
															);
														setCopiedUrl(getreview.customer_sd_url);
														setTimeout(() => setCopiedUrl(''), 2000);
													}}>
													{copiedUrl === getreview.customer_sd_url
														? 'Copied'
														: 'Copy'}
												</span>
											</li>
										)}
										{getreview.employee_sd_url && (
											<li
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
												}}>
												<span>
													Employee:{' '}
													<span style={{ fontFamily: 'monospace' }}>
														{getreview.employee_sd_url}
													</span>
												</span>
												<span
													style={{
														fontSize: 12,
														color: '#4d69fa',
														cursor: 'pointer',
														marginLeft: 8,
													}}
													onClick={() => {
														navigator.clipboard &&
															navigator.clipboard.writeText(
																getreview.employee_sd_url,
															);
														setCopiedUrl(getreview.employee_sd_url);
														setTimeout(() => setCopiedUrl(''), 2000);
													}}>
													{copiedUrl === getreview.employee_sd_url
														? 'Copied'
														: 'Copy'}
												</span>
											</li>
										)}
									</ul>
								</div>
							)}

							<div style={{ marginTop: 12 }}>
								<div
									style={{
										fontSize: 13,
										fontWeight: 700,
										color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
									}}>
									Opening & Closing Hours
								</div>
								<div>
									<ul style={{ margin: 8, paddingLeft: 18 }}>
										{getreview.opening_hours &&
										typeof getreview.opening_hours === 'object' &&
										!Array.isArray(getreview.opening_hours) ? (
											Object.entries(getreview.opening_hours).map(
												([key, hour]) => {
													const parseDayName = (k, h) => {
														if (
															typeof h === 'object' &&
															h !== null &&
															h.day
														)
															return h.day;
														const maybeNum = (v) => {
															const n = Number(v);
															return !isNaN(n) && n >= 1 && n <= 7
																? daysOfWeek[n - 1]
																: null;
														};
														const fromHour = maybeNum(h);
														if (fromHour) return fromHour;
														const fromKey = maybeNum(k);
														if (fromKey) return fromKey;
														return k;
													};

													if (typeof hour === 'object' && hour !== null) {
														const dayLabel =
															hour.day || parseDayName(key, hour);
														return (
															<li key={key}>
																{`${dayLabel}: ${
																	hour.open || '--'
																} - ${hour.close || '--'}`}
															</li>
														);
													}
													if (
														!isNaN(Number(hour)) &&
														Number(hour) >= 1 &&
														Number(hour) <= 7
													) {
														return (
															<li key={key}>
																{daysOfWeek[Number(hour) - 1]}
															</li>
														);
													}

													if (
														!isNaN(Number(key)) &&
														Number(key) >= 1 &&
														Number(key) <= 7
													) {
														return (
															<li key={key}>
																{`${
																	daysOfWeek[Number(key) - 1]
																}: ${hour}`}
															</li>
														);
													}

													return <li key={key}>{String(hour)}</li>;
												},
											)
										) : getreview.opening_hours &&
										  typeof getreview.opening_hours === 'string' ? (
											<li>{getreview.opening_hours}</li>
										) : businessInfo.hours && businessInfo.hours.length > 0 ? (
											businessInfo.hours.map((h, i) => (
												<li key={h.day || i}>
													{h.day}: {h.open || '--'} - {h.close || '--'}
												</li>
											))
										) : (
											<li>Not set</li>
										)}
									</ul>
								</div>
							</div>

							<div
								style={{
									marginTop: 12,
									display: 'flex',
									gap: 12,
									alignItems: 'flex-start',
									flexWrap: 'wrap',
								}}>
								<div style={{ minWidth: 180 }}>
									<div
										style={{
											fontSize: 13,
											fontWeight: 700,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
										}}>
										Logo Light
									</div>
									<div style={{ marginTop: 8 }}>
										{getreview.logo_light ? (
											<span style={logoBoxStyle}>
												<img
													src={getreview.logo_light}
													alt='Logo-Light'
													style={logoImgStyle}
												/>
											</span>
										) : businessInfo.logoWhite &&
										  businessInfo.logoWhite.length > 0 ? (
											businessInfo.logoWhite.map((img) => (
												<span key={img.id} style={logoBoxStyle}>
													<img
														src={img.file}
														alt='Logo-Light'
														style={logoImgStyle}
													/>
												</span>
											))
										) : (
											<span style={{ color: '#888' }}>Not uploaded</span>
										)}
									</div>
								</div>
								<div style={{ minWidth: 180 }}>
									<div
										style={{
											fontSize: 13,
											fontWeight: 700,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
										}}>
										Logo Dark
									</div>
									<div style={{ marginTop: 8 }}>
										{getreview.logo_dark ? (
											<span style={logoBoxStyle}>
												<img
													src={getreview.logo_dark}
													alt='Logo-Dark'
													style={logoImgStyle}
												/>
											</span>
										) : businessInfo.logoDark &&
										  businessInfo.logoDark.length > 0 ? (
											businessInfo.logoDark.map((img) => (
												<span key={img.id} style={logoBoxStyle}>
													<img
														src={img.file}
														alt='Logo-Dark'
														style={logoImgStyle}
													/>
												</span>
											))
										) : (
											<span style={{ color: '#888' }}>Not uploaded</span>
										)}
									</div>
								</div>
								<div style={{ minWidth: 120 }}>
									<div
										style={{
											fontSize: 13,
											fontWeight: 700,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
										}}>
										Logo Mobile
									</div>
									<div style={{ marginTop: 8 }}>
										{getreview.logo_mobile ? (
											<span style={logoMobileBoxStyle}>
												<img
													src={getreview.logo_mobile}
													alt='Logo-Mobile'
													style={logoImgStyle}
												/>
											</span>
										) : businessInfo.logoMobile &&
										  businessInfo.logoMobile.length > 0 ? (
											businessInfo.logoMobile.map((img) => (
												<span key={img.id} style={logoMobileBoxStyle}>
													<img
														src={img.file}
														alt='Logo-Mobile'
														style={logoImgStyle}
													/>
												</span>
											))
										) : (
											<span style={{ color: '#888' }}>Not uploaded</span>
										)}
									</div>
								</div>
								<div style={{ minWidth: 120 }}>
									<div
										style={{
											fontSize: 13,
											fontWeight: 700,
											color: themeStatus === 'dark' ? '#cfd6ef' : '#556',
										}}>
										Favicon
									</div>
									<div style={{ marginTop: 8 }}>
										{getreview.logo_favicon ? (
											<span style={logoMobileBoxStyle}>
												<img
													src={getreview.logo_favicon}
													alt='Site-Favicon'
													style={logoImgStyle}
												/>
											</span>
										) : businessInfo.favicon &&
										  businessInfo.favicon.length > 0 ? (
											businessInfo.favicon.map((img) => (
												<span key={img.id} style={logoMobileBoxStyle}>
													<img
														src={img.file}
														alt='Site-Favicon'
														style={logoImgStyle}
													/>
												</span>
											))
										) : (
											<span style={{ color: '#888' }}>Not uploaded</span>
										)}
									</div>
								</div>
							</div>
						</div>
						<div
							className='onboarding-summary review-card'
							style={{
								background: summaryBg,
								border: summaryBorder,
								padding: 18,
								borderRadius: 12,
								boxShadow:
									themeStatus === 'dark'
										? '0 6px 20px rgba(0,0,0,0.6)'
										: '0 8px 22px rgba(15,23,42,0.06)',
								justifySelf: 'stretch',
							}}>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}>
								<h4 style={{ margin: 0 }}>Selected Plan </h4>
								<button
									className='onboarding-btn'
									style={{ padding: '4px 18px', fontSize: 14, margin: 0 }}
									onClick={() => setStep(2)}>
									Edit
								</button>
							</div>
							{plan ? (
								<>
									{(() => {
										const reviewIsTrial =
											getreview?.is_trail_version ??
											getreview?.is_trial_version ??
											null;
										const isTrial =
											reviewIsTrial === 1 ||
											reviewIsTrial === '1' ||
											reviewIsTrial === true ||
											reviewIsTrial === 'true';
										const displayCurrency = (
											(getreview && getreview.package_currency) ||
											plan.package_currency ||
											plan.currency ||
											businessInfo.currency ||
											'LKR'
										).toString();

										const currencyCode = displayCurrency.toUpperCase();
										const currencySymbol =
											currencyCode === 'USD'
												? '$'
												: currencyCode === 'LKR'
												? 'LKR '
												: currencyCode + ' ';
										const rawPrice =
											currencyCode === 'USD' && plan.package_price_usd != null
												? plan.package_price_usd
												: plan.package_price ?? plan.price ?? 0;

										const formattedPrice = (() => {
											const num = parseFloat(rawPrice);
											if (Number.isFinite(num)) {
												if (currencyCode === 'USD') {
													return num.toLocaleString(undefined, {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													});
												}
												return num.toLocaleString();
											}
											return String(rawPrice || '0');
										})();

										return (
											<>
												<div>
													<b>Plan:</b>{' '}
													{plan.package_name || 'Free (Lifetime)'}{' '}
													{isTrial && (
														<span
															style={{
																color: '#4d69fa',
																fontWeight: 700,
																marginLeft: 8,
															}}>
															(14-day free trial)
														</span>
													)}
												</div>
												<div>
													<b>Price:</b> {currencySymbol}
													{formattedPrice} / {plan.period || 'month'}
												</div>
											</>
										);
									})()}
									<div>
										<b>Users:</b> Unlimited
									</div>
									<div>
										<b>Features:</b>
										<ul style={{ margin: 0, paddingLeft: 18 }}>
											{plan.package_features &&
											typeof plan.package_features === 'object' &&
											!Array.isArray(plan.package_features)
												? Object.entries(plan.package_features).map(
														([key, value], i) => {
															const featureName = key
																.replace(/_/g, ' ')
																.replace(/\b\w/g, (l) =>
																	l.toUpperCase(),
																);
															let featureValue = value;
															if (
																value === '' ||
																value === null ||
																value === undefined
															)
																featureValue = 'Unlimited';
															else if (
																value === true ||
																value === 'true'
															)
																featureValue = 'Yes';
															else if (
																value === false ||
																value === 'false'
															)
																featureValue = 'No';
															return (
																<li key={i}>
																	{featureName}: {featureValue}
																</li>
															);
														},
												  )
												: Array.isArray(plan.package_features)
												? plan.package_features.map((f, i) => (
														<li key={i}>{f}</li>
												  ))
												: Array.isArray(plan.features)
												? plan.features.map((f, i) => <li key={i}>{f}</li>)
												: null}
										</ul>
									</div>
									<div style={{ color: '#4d69fa', fontSize: 13 }}>
										{plan.note}
									</div>
								</>
							) : (
								<div
									style={{
										color: themeStatus === 'dark' ? '#bfc6d6' : '#556',
										fontSize: 14,
										padding: 0,
									}}>
									No plan selected.
								</div>
							)}
						</div>
						<div className='onboarding-checkbox' style={{ gridColumn: '1 / -1' }}>
							<input
								type='checkbox'
								id='review-accept'
								checked={reviewAccepted}
								onChange={(e) => setReviewAccepted(e.target.checked)}
								style={{ width: 18, height: 18 }}
							/>
							<label
								htmlFor='review-accept'
								style={{ fontWeight: 500, cursor: 'pointer' }}>
								I confirm that the above information is correct.
							</label>
						</div>
						<div className='onboarding-checkbox' style={{ gridColumn: '1 / -1' }}>
							<input
								type='checkbox'
								id='terms-accept'
								checked={termsAccepted}
								onChange={(e) => setTermsAccepted(e.target.checked)}
								style={{ width: 18, height: 18 }}
							/>
							<label
								htmlFor='terms-accept'
								style={{ fontWeight: 500, cursor: 'pointer' }}>
								I have read and agree to the{' '}
								<RouterLink
									to='/terms'
									target='_blank'
									rel='noopener noreferrer'
									style={{ color: '#4d69fa', fontWeight: 700 }}>
									Terms & Conditions
								</RouterLink>{' '}
								and{' '}
								<RouterLink
									to='/privacy'
									target='_blank'
									rel='noopener noreferrer'
									style={{ color: '#4d69fa', fontWeight: 700 }}>
									Privacy Policy
								</RouterLink>
								.
							</label>
						</div>
					</>
				)}
			</div>
		);
	};

	const renderPayment = () => {
		const summaryBg = themeStatus === 'dark' ? '#23263a' : '#f8f9fa';
		const summaryBorder = themeStatus === 'dark' ? '1px solid #35395a' : '2px solid #eee';

		const plan = selectedPlan;
		const rawPrice = plan ? parseFloat(plan.package_price) || parseFloat(plan.price) || 0 : 0;
		const isFreePlan = rawPrice === 0;

		let price = rawPrice;
		let discount = 0;
		let periodLabel = 'per month';
		if (!isFreePlan) {
			if (billingPeriod === '6months') {
				discount = 0.1;
				price = plan ? rawPrice * 6 * (1 - discount) : 0;
				periodLabel = 'for 6 months (10% off)';
			} else if (billingPeriod === 'yearly') {
				discount = 0.2;
				price = plan ? rawPrice * 12 * (1 - discount) : 0;
				periodLabel = 'per year (20% off)';
			} else {
				price = rawPrice;
				periodLabel = 'per month';
			}
		}
		const reviewIsTrial = (() => {
			try {
				const v = getreview?.is_trail_version ?? getreview?.is_trial_version ?? null;
				return v === 1 || v === '1' || v === true || v === 'true';
			} catch (e) {
				return false;
			}
		})();
		const effectivePaymentMethod = (() => {
			if (isFreePlan) return 'free';
			if (reviewIsTrial) return 'trial';
			return paymentMethod || 'bank';
		})();

		const MAX_FILES = 6;
		const MAX_SIZE_MB = 5;
		const ALLOWED_TYPES = [
			'image/jpeg',
			'image/png',
			'image/gif',
			'image/webp',
			'image/bmp',
			'image/svg+xml',
			'application/pdf',
		];

		const handleBankReceiptUpload = async (eOrFiles) => {
			setBankReceiptError('');
			let files = [];
			try {
				if (!eOrFiles) return;
				if (eOrFiles && eOrFiles.dataTransfer && eOrFiles.dataTransfer.files) {
					files = Array.from(eOrFiles.dataTransfer.files || []);
				} else if (eOrFiles && eOrFiles.target && eOrFiles.target.files) {
					files = Array.from(eOrFiles.target.files || []);
				} else if (Array.isArray(eOrFiles)) {
					files = eOrFiles;
				} else if (eOrFiles.files) {
					files = Array.from(eOrFiles.files || []);
				}
			} catch (err) {
				files = [];
			}
			if (!files.length) return;
			setBankDragActive(false);
			if (localBankReceipt.length + files.length > MAX_FILES) {
				setBankReceiptError(`Cannot upload more than ${MAX_FILES} files.`);
				return;
			}

			const existing = localBankReceipt.map((f) => f.name + '_' + f.size);
			const validFiles = files.filter((file) => {
				if (!ALLOWED_TYPES.includes(file.type)) {
					setBankReceiptError('Only images and PDF files are allowed.');
					return false;
				}
				if (file.size > MAX_SIZE_MB * 1024 * 1024) {
					setBankReceiptError(`File size must be under ${MAX_SIZE_MB}MB.`);
					return false;
				}
				if (existing.includes(file.name + '_' + file.size)) {
					setBankReceiptError('Duplicate file: ' + file.name);
					return false;
				}
				return true;
			});
			if (!validFiles.length) return;
			const fileReaders = validFiles.map((file) => {
				return new Promise((resolve) => {
					const reader = new FileReader();
					reader.onload = () => {
						let url;
						if (file.type.startsWith('image/') || file.type === 'application/pdf') {
							url = URL.createObjectURL(file);
						} else {
							url = reader.result;
						}
						resolve({
							id: Date.now() + Math.random(),
							file: reader.result,
							name: file.name,
							type: file.type,
							size: file.size,
							url,
						});
					};
					reader.readAsArrayBuffer(file);
				});
			});
			Promise.all(fileReaders).then(async (images) => {
				setLocalBankReceipt(images);
				setBankReceipt([]);
				setBankReceiptError('');
				setBankUploading(true);
				const uploadedUrls = [];
				try {
					for (const img of images) {
						let blob = null;
						try {
							if (img.file instanceof ArrayBuffer) {
								blob = new Blob([img.file], {
									type: img.type || 'application/octet-stream',
								});
							} else if (
								typeof img.file === 'string' &&
								img.file.startsWith('data:')
							) {
								const res = await fetch(img.file);
								blob = await res.blob();
							} else if (img.file && img.file instanceof Blob) {
								blob = img.file;
							} else if (img.url) {
								const res = await fetch(img.url);
								blob = await res.blob();
							}
						} catch (e) {
							blob = null;
						}
						if (!blob) {
							throw new Error(
								'Failed to prepare receipt file for upload: ' + img.name,
							);
						}

						const formData = new FormData();
						formData.append('receipt[0]', blob, img.name || 'receipt');
						try {
							formData.append('salon_name', businessInfo.salonName || '');
						} catch (e) {}

						const resp = await uploadImage({ formData });
						const data = resp && resp.data ? resp.data : null;
						if (
							data &&
							(data.type === 'success' || data.type === 'Success') &&
							data.url
						) {
							uploadedUrls.push(data.url);
							setLocalBankReceipt((prev) =>
								prev.map((p) =>
									p.id === img.id
										? {
												...p,
												uploaded: true,
												uploadedUrl: data.url,
												url: data.url,
										  }
										: p,
								),
							);
						} else if (
							data &&
							data.urls &&
							Array.isArray(data.urls) &&
							data.urls.length
						) {
							uploadedUrls.push(...data.urls);
							setLocalBankReceipt((prev) =>
								prev.map((p) =>
									p.id === img.id
										? {
												...p,
												uploaded: true,
												uploadedUrl: data.urls[0],
												url: data.urls[0],
										  }
										: p,
								),
							);
						} else {
							throw new Error((data && data.message) || 'Receipt upload failed');
						}
					}
				} catch (err) {
					setBankReceiptError(err?.message || 'Failed to upload receipts');
					setLocalBankReceipt([]);
					setBankReceipt([]);
					setBankInputKey(Date.now());
				} finally {
					setBankUploading(false);
				}
			});
		};

		const handleSubmitPayment = async () => {
			try {
				if (bankUploading) return;
				const email = (businessInfo?.email || '').trim();
				setReviewLoading(true);
				setReviewFetchError('');
				let latestReview = {};
				let latestReviewPlan = {};
				let latestReviewError = '';
				try {
					if (!email) {
						latestReview = {};
						latestReviewPlan = {};
						latestReviewError =
							'Please enter your business email on the Business Info step to load review information.';
					} else {
						const item = { action: 'get_review_info', email };
						const flechdata = await apiServicewt(item, navigate);
						if (
							flechdata &&
							(flechdata.type === 'Success' || flechdata.type === 'success')
						) {
							if (
								flechdata.is_email_verified === false ||
								flechdata.is_email_verified === 'false'
							) {
								latestReview = {};
								latestReviewPlan = {};
								latestReviewError =
									'The provided email is not verified. Please verify the email on the Business Info step before continuing.';
							} else {
								latestReview = flechdata.data || {};
								latestReviewPlan = flechdata.data?.package_details || {};
								latestReviewError = '';
							}
						} else {
							latestReview = {};
							latestReviewPlan = {};
							latestReviewError =
								flechdata?.message || 'Failed to load review information.';
						}
						setGetreview(latestReview);
						setGetreviewplan(latestReviewPlan);
						setReviewFetchError(latestReviewError);
					}
				} catch (err) {
					latestReview = {};
					latestReviewPlan = {};
					latestReviewError = 'Failed to load review information. Please try again.';
					setGetreview({});
					setGetreviewplan({});
					setReviewFetchError(latestReviewError);
				} finally {
					setReviewLoading(false);
				}
				if (!email) {
					startmodel();
					setMsgLoadalert(
						'Please enter your business email on the Business Info step to continue.',
					);
					setMsgtypeLoadalert('Error');
					return;
				}
				if (
					(latestReview &&
						(latestReview.is_email_verified === false ||
							latestReview.is_email_verified === 'false')) ||
					(latestReviewError &&
						String(latestReviewError).toLowerCase().includes('not verified')) ||
					(getreview &&
						(getreview.is_email_verified === false ||
							getreview.is_email_verified === 'false')) ||
					(reviewFetchError &&
						String(reviewFetchError).toLowerCase().includes('not verified'))
				) {
					startmodel();
					setMsgLoadalert(
						latestReviewError ||
							reviewFetchError ||
							'Please verify your business email on the Business Info step before submitting.',
					);
					setMsgtypeLoadalert('Error');
					return;
				}
				const bizValidation = validateBusinessInfo();
				if (Object.keys(bizValidation).length > 0) {
					setErrors((prev) => ({ ...prev, ...bizValidation }));
					startmodel();
					setMsgLoadalert(
						'Please complete the required Business Info before submitting payment.',
					);
					setMsgtypeLoadalert('Error');
					setStep(1);
					return;
				}
				if (!selectedPlan || !getreviewplan || Object.keys(getreviewplan).length === 0) {
					startmodel();
					setMsgLoadalert(
						'Please select a plan and ensure review information is loaded before submitting.',
					);
					setMsgtypeLoadalert('Error');
					setStep(2);
					return;
				}
				if (!reviewAccepted || !termsAccepted) {
					startmodel();
					setMsgLoadalert(
						'Please confirm the review and accept the Terms & Conditions on the Review step.',
					);
					setMsgtypeLoadalert('Error');
					setStep(3);
					return;
				}
				const uploaded = bankReceipt || [];
				if (
					!isFreePlan &&
					effectivePaymentMethod !== 'trial' &&
					(!uploaded || uploaded.length === 0)
				) {
					startmodel();
					setMsgLoadalert('Please upload at least one valid receipt before submitting.');
					setMsgtypeLoadalert('Error');
					setStep(4);
					return;
				}
				const rawPrice = plan
					? parseFloat(plan.package_price) || parseFloat(plan.price) || 0
					: 0;
				let paid_amount = 0;
				let billing_period_months = null;
				if (!isFreePlan) {
					if (billingPeriod === '6months') {
						billing_period_months = 6;
						paid_amount = rawPrice * 6 * (1 - 0.1);
					} else if (billingPeriod === 'yearly') {
						billing_period_months = 12;
						paid_amount = rawPrice * 12 * (1 - 0.2);
					} else {
						billing_period_months = 1;
						paid_amount = rawPrice;
					}
				}
				let payload = {
					action: 'submit_onboarding',
					email: email,
				};

				if (effectivePaymentMethod === 'free') {
					payload = {
						...payload,
						payment_method: '',
						paid_receipt: '',
						paid_amount: '',
						billing_period: null,
					};
				} else if (effectivePaymentMethod === 'trial') {
					payload = {
						...payload,
						payment_method: 'trial',
						paid_receipt: uploaded && uploaded.length ? JSON.stringify(uploaded) : '',
						paid_amount: Math.round(paid_amount),
						billing_period: billing_period_months,
					};
				} else {
					payload = {
						...payload,
						payment_method: paymentMethod === 'bank' ? 'bank_transfer' : paymentMethod,
						paid_receipt: JSON.stringify(uploaded || []),
						paid_amount: Math.round(paid_amount),
						billing_period: billing_period_months,
					};
				}

				setSubmitting(true);
				const resp = await apiServicewt(payload, navigate);
				if (resp && (resp.type === 'success' || resp.type === 'Success')) {
					startmodel();
					setMsgLoadalert(resp.message || 'Payment submitted successfully.');
					setMsgtypeLoadalert('Success');
					setBankReceipt([]);
					setLocalBankReceipt([]);
					setBankInputKey(Date.now());
					handleStartNew();
					setStep(0);
					return true;
				} else {
					startmodel();
					setMsgLoadalert(resp?.message || 'Payment submission failed.');
					setMsgtypeLoadalert('error');
					return false;
				}
			} catch (err) {
				console.error('submit payment error', err);
				startmodel();
				setMsgLoadalert(err?.message || 'Payment submission failed.');
				setMsgtypeLoadalert('error');
				return false;
			} finally {
				setSubmitting(false);
			}
		};

		const handlePayPalPayment = async () => {
			try {
				if (bankUploading) return;
				const email = (businessInfo?.email || '').trim();
				setReviewLoading(true);
				setReviewFetchError('');
				let latestReview = {};
				let latestReviewPlan = {};
				let latestReviewError = '';
				try {
					if (!email) {
						latestReview = {};
						latestReviewPlan = {};
						latestReviewError =
							'Please enter your business email on the Business Info step to load review information.';
					} else {
						const item = { action: 'get_review_info', email };
						const flechdata = await apiServicewt(item, navigate);
						if (
							flechdata &&
							(flechdata.type === 'Success' || flechdata.type === 'success')
						) {
							if (
								flechdata.is_email_verified === false ||
								flechdata.is_email_verified === 'false'
							) {
								latestReview = {};
								latestReviewPlan = {};
								latestReviewError =
									'The provided email is not verified. Please verify the email on the Business Info step before continuing.';
							} else {
								latestReview = flechdata.data || {};
								latestReviewPlan = flechdata.data?.package_details || {};
								latestReviewError = '';
							}
						} else {
							latestReview = {};
							latestReviewPlan = {};
							latestReviewError =
								flechdata?.message || 'Failed to load review information.';
						}
						setGetreview(latestReview);
						setGetreviewplan(latestReviewPlan);
						setReviewFetchError(latestReviewError);
					}
				} catch (err) {
					latestReview = {};
					latestReviewPlan = {};
					latestReviewError = 'Failed to load review information. Please try again.';
					setGetreview({});
					setGetreviewplan({});
					setReviewFetchError(latestReviewError);
				} finally {
					setReviewLoading(false);
				}
				if (!email) {
					startmodel();
					setMsgLoadalert(
						'Please enter your business email on the Business Info step to continue.',
					);
					setMsgtypeLoadalert('Error');
					return;
				}
				if (
					(latestReview &&
						(latestReview.is_email_verified === false ||
							latestReview.is_email_verified === 'false')) ||
					(latestReviewError &&
						String(latestReviewError).toLowerCase().includes('not verified')) ||
					(getreview &&
						(getreview.is_email_verified === false ||
							getreview.is_email_verified === 'false')) ||
					(reviewFetchError &&
						String(reviewFetchError).toLowerCase().includes('not verified'))
				) {
					startmodel();
					setMsgLoadalert(
						latestReviewError ||
							reviewFetchError ||
							'Please verify your business email on the Business Info step before proceeding to payment.',
					);
					setMsgtypeLoadalert('Error');
					return;
				}
				const bizValidation = validateBusinessInfo();
				if (Object.keys(bizValidation).length > 0) {
					setErrors((prev) => ({ ...prev, ...bizValidation }));
					startmodel();
					setMsgLoadalert(
						'Please complete the required Business Info before proceeding to payment.',
					);
					setMsgtypeLoadalert('Error');
					setStep(1);
					return;
				}
				if (!selectedPlan || !getreviewplan || Object.keys(getreviewplan).length === 0) {
					startmodel();
					setMsgLoadalert(
						'Please select a plan and ensure review information is loaded before proceeding to PayPal.',
					);
					setMsgtypeLoadalert('Error');
					setStep(2);
					return;
				}
				if (!reviewAccepted || !termsAccepted) {
					startmodel();
					setMsgLoadalert(
						'Please confirm the review and accept the Terms & Conditions on the Review step.',
					);
					setMsgtypeLoadalert('Error');
					setStep(3);
					return;
				}
				const rawPrice = plan
					? parseFloat(plan.package_price) || parseFloat(plan.price) || 0
					: 0;
				let paid_amount = 0;
				let billing_period_months = null;
				if (!isFreePlan) {
					if (billingPeriod === '6months') {
						billing_period_months = 6;
						paid_amount = rawPrice * 6 * (1 - 0.1);
					} else if (billingPeriod === 'yearly') {
						billing_period_months = 12;
						paid_amount = rawPrice * 12 * (1 - 0.2);
					} else {
						billing_period_months = 1;
						paid_amount = rawPrice;
					}
				}

				const uploaded = bankReceipt || [];
				if (!isFreePlan && (!uploaded || uploaded.length === 0)) {
					startmodel();
					setMsgLoadalert(
						'Please upload at least one valid receipt before proceeding to PayPal.',
					);
					setMsgtypeLoadalert('Error');
					setStep(4);
					return;
				}

				const payload = {
					action: 'submit_onboarding',
					email: email,
					payment_method: 'paypal',
					paid_receipt: JSON.stringify(uploaded || []),
					paid_amount: Math.round(paid_amount),
					billing_period: billing_period_months,
				};

				setSubmitting(true);
				const resp = await apiServicewt(payload, navigate);
				if (resp && (resp.type === 'success' || resp.type === 'Success')) {
					const paymentUrl = resp?.data?.payment_url || resp?.payment_url || null;
					if (paymentUrl) {
						window.location.href = paymentUrl;
						return true;
					}
					startmodel();
					setMsgLoadalert(resp.message || 'Payment initiated successfully.');
					setMsgtypeLoadalert('Success');
					setBankReceipt([]);
					setLocalBankReceipt([]);
					setBankInputKey(Date.now());
					handleStartNew();
					setStep(0);
					return true;
				} else {
					startmodel();
					setMsgLoadalert(resp?.message || 'Failed to initiate PayPal payment.');
					setMsgtypeLoadalert('error');
					return false;
				}
			} catch (err) {
				console.error('PayPal payment error', err);
				startmodel();
				setMsgLoadalert(err?.message || 'Failed to initiate PayPal payment.');
				setMsgtypeLoadalert('error');
				return false;
			} finally {
				setSubmitting(false);
			}
		};

		const handleDeleteReceipt = (id) => {
			setLocalBankReceipt((prev) => {
				const updated = prev.filter((img) => img.id !== id);
				if (updated.length === 0) setBankInputKey(Date.now());
				return updated;
			});
		};

		return (
			<div style={{ maxWidth: '100%', margin: '0 auto' }}>
				<StepHeader
					title='Complete Your Registration'
					subtitle='Confirm your selected plan and complete business setup.'
					hideNext
					backLabel='Previous Step'
					nextLabel={
						reviewLoading
							? 'Loading...'
							: effectivePaymentMethod === 'trial'
							? 'Start Free Trial'
							: effectivePaymentMethod === 'free'
							? 'Complete Setup'
							: effectivePaymentMethod === 'bank'
							? 'Submit Bank Transfer'
							: 'Proceed to PayPal'
					}
					disableNext={reviewLoading || !plan || bankUploading || submitting}
					onBack={() => setStep(3)}
					onNext={async () => {
						if (reviewLoading) return;
						if (effectivePaymentMethod === 'trial') {
							await handleSubmitPayment();
						} else if (effectivePaymentMethod === 'bank') {
							await handleSubmitPayment();
						} else if (effectivePaymentMethod === 'free') {
							await handleSubmitPayment();
						} else {
							await handlePayPalPayment();
						}
					}}
				/>
				<div
					className='onboarding-summary review-card'
					style={{ marginBottom: 24, background: summaryBg, border: summaryBorder }}>
					<h4 style={{ marginTop: 0 }}>Selected Plan</h4>
					{reviewLoading ? (
						<div style={{ padding: 18, textAlign: 'center' }}>
							<div
								className='spinner-border'
								role='status'
								style={{ width: 36, height: 36, borderWidth: 3 }}>
								<span className='visually-hidden'>Loading review details...</span>
							</div>
							<div style={{ marginTop: 8 }}>Loading review details...</div>
						</div>
					) : plan ? (
						<>
							<div>
								<b>Plan:</b> {plan.package_name || 'Free (Lifetime)'}
							</div>
							{(() => {
								const displayCurrency = (
									(getreview && getreview.package_currency) ||
									plan.package_currency ||
									plan.currency ||
									businessInfo.currency ||
									'LKR'
								).toString();
								const currencyCode = displayCurrency.toUpperCase();
								const currencySymbol =
									currencyCode === 'USD'
										? '$'
										: currencyCode === 'LKR'
										? 'LKR '
										: currencyCode + ' ';

								const rawPrice =
									currencyCode === 'USD' && plan.package_price_usd != null
										? plan.package_price_usd
										: plan.package_price ?? plan.price ?? 0;

								const formattedPrice = (() => {
									const num = parseFloat(rawPrice);
									if (Number.isFinite(num)) {
										if (currencyCode === 'USD') {
											return num.toLocaleString(undefined, {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											});
										}
										return num.toLocaleString();
									}
									return String(rawPrice || '0');
								})();

								return (
									<div>
										<b>Price:</b> {currencySymbol}
										{formattedPrice} / {plan.period || 'month'}
									</div>
								);
							})()}

							{reviewIsTrial && (
								<div style={{ marginTop: 8, color: '#4d69fa', fontWeight: 600 }}>
									Activate your 14-day free trial now and explore all premium
									features—no card, no payment required.
								</div>
							)}
						</>
					) : (
						<div
							style={{
								color: themeStatus === 'dark' ? '#bfc6d6' : '#556',
								fontSize: 14,
								padding: 0,
							}}>
							No plan selected.
						</div>
					)}
				</div>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
					<button
						type='button'
						className='onboarding-btn'
						disabled={reviewLoading || !plan || bankUploading || submitting}
						onClick={async () => {
							if (reviewLoading) return;
							if (effectivePaymentMethod === 'trial') {
								await handleSubmitPayment();
							} else if (effectivePaymentMethod === 'bank') {
								await handleSubmitPayment();
							} else if (effectivePaymentMethod === 'free') {
								await handleSubmitPayment();
							} else {
								await handlePayPalPayment();
							}
						}}
						style={{
							minWidth: 240,
							fontWeight: 700,
							marginTop: 0,
						}}>
						{reviewLoading
							? 'Loading...'
							: effectivePaymentMethod === 'trial'
							? 'Start Free Trial'
							: effectivePaymentMethod === 'free'
							? 'Complete Setup'
							: effectivePaymentMethod === 'bank'
							? 'Submit Bank Transfer'
							: 'Proceed to PayPal'}
					</button>
				</div>
				{/* <div
					className='onboarding-summary'
					style={{ marginBottom: 24, background: summaryBg, border: summaryBorder }}>
					<h4 style={{ marginTop: 0 }}>Choose Billing Period</h4>
					<div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
						<button
							className={`onboarding-btn${
								billingPeriod === 'monthly' ? ' selected' : ''
							}`}
							style={{
								padding: '8px 24px',
								background: billingPeriod === 'monthly' ? '#4d69fa' : '#aaa',
							}}
							onClick={() => setBillingPeriod('monthly')}>
							Monthly
						</button>
						{!isFreePlan && !reviewIsTrial && (
							<>
								<button
									className={`onboarding-btn${
										billingPeriod === '6months' ? ' selected' : ''
									}`}
									style={{
										padding: '8px 24px',
										background:
											billingPeriod === '6months' ? '#4d69fa' : '#aaa',
									}}
									onClick={() => setBillingPeriod('6months')}>
									6 Months <span style={{ fontWeight: 500 }}>(10% off)</span>
								</button>
								<button
									className={`onboarding-btn${
										billingPeriod === 'yearly' ? ' selected' : ''
									}`}
									style={{
										padding: '8px 24px',
										background: billingPeriod === 'yearly' ? '#4d69fa' : '#aaa',
									}}
									onClick={() => setBillingPeriod('yearly')}>
									Yearly <span style={{ fontWeight: 500 }}>(20% off)</span>
								</button>
							</>
						)}
					</div>
					<div style={{ fontWeight: 600, fontSize: 18, marginTop: 8 }}>
						Total: {plan ? plan.currency : ''}
						{(isFreePlan ? 0 : price).toLocaleString()}{' '}
						<span style={{ fontSize: 15, color: '#888', fontWeight: 400 }}>
							/{' '}
							{billingPeriod === 'monthly'
								? 'month'
								: billingPeriod === '6months'
								? '6 months'
								: 'year'}
						</span>
					</div>
				</div>
				{!isFreePlan && plan && (
					<div
						className='onboarding-summary'
						style={{ marginBottom: 24, background: summaryBg, border: summaryBorder }}>
						<h4 style={{ marginTop: 0 }}>Choose Payment Method</h4>
						<div
							style={{
								display: 'flex',
								gap: 16,
								marginBottom: 16,
								flexWrap: 'wrap',
							}}>
							<button
								className={`onboarding-btn${
									effectivePaymentMethod === 'bank' || paymentMethod === 'bank'
										? ' selected'
										: ''
								}`}
								style={{
									padding: '8px 24px',
									background:
										effectivePaymentMethod === 'bank' ||
										paymentMethod === 'bank'
											? '#4d69fa'
											: '#aaa',
								}}
								onClick={() => setPaymentMethod('bank')}>
								Pay by Bank Transfer
							</button>
						</div>
						{(effectivePaymentMethod === 'bank' || paymentMethod === 'bank') && (
							<div style={{ marginTop: 12 }}>
								<div style={{ fontWeight: 500, marginBottom: 8 }}>
									Upload Bank Receipt(s):
								</div>
								<div
									onDragOver={(e) => {
										e.preventDefault();
										setBankDragActive(true);
									}}
									onDragEnter={(e) => {
										e.preventDefault();
										setBankDragActive(true);
									}}
									onDragLeave={() => setBankDragActive(false)}
									onDrop={(e) => {
										e.preventDefault();
										setBankDragActive(false);
										handleBankReceiptUpload(e);
									}}
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										flexDirection: 'column',
										padding: 18,
										borderRadius: 10,
										border: bankDragActive
											? '2px dashed #4d69fa'
											: '2px dashed #35395a',
										background: bankDragActive
											? themeStatus === 'dark'
												? '#1f2430'
												: '#f5f8ff'
											: themeStatus === 'dark'
											? '#141518'
											: '#fafafa',
										cursor: 'pointer',
										marginBottom: 15,
									}}>
									<div style={{ fontSize: 34 }}>
										{bankDragActive ? '📂' : '📁'}
									</div>
									<div style={{ fontWeight: 700, marginTop: 8 }}>
										Drag & drop receipts here
									</div>
									<div style={{ color: '#666', fontSize: 13, marginTop: 6 }}>
										or{' '}
										<span
											style={{
												color: '#4d69fa',
												textDecoration: 'underline',
												cursor: 'pointer',
											}}
											onClick={() =>
												bankFileInputRef.current &&
												bankFileInputRef.current.click()
											}>
											click to browse
										</span>
									</div>
									<div style={{ color: '#888', fontSize: 12, marginTop: 8 }}>
										Allowed: JPG, PNG, GIF, WEBP, BMP, SVG, PDF — Max{' '}
										{MAX_SIZE_MB}MB each
									</div>
									<input
										ref={bankFileInputRef}
										key={bankInputKey}
										type='file'
										accept='image/*,application/pdf'
										multiple
										onChange={handleBankReceiptUpload}
										style={{ display: 'none' }}
									/>
								</div>
								{bankReceiptError && (
									<div
										style={{
											color: 'red',
											fontSize: 13,
											marginTop: 8,
										}}>
										{bankReceiptError}
									</div>
								)}
								<div
									style={{
										marginTop: 8,
										display: 'flex',
										flexWrap: 'wrap',
										gap: 12,
									}}>
									{localBankReceipt.map((img) => {
										const isPdf =
											img.type === 'application/pdf' ||
											(img.file &&
												img.file.startsWith &&
												img.file.startsWith('data:application/pdf'));
										const boxBg =
											themeStatus === 'dark' ? '#23263a' : '#f5f5f5';
										const boxBorder =
											themeStatus === 'dark' ? '#35395a' : '#eee';
										const fileNameColor =
											themeStatus === 'dark' ? '#fff' : '#333';
										return (
											<div
												key={img.id}
												style={{
													position: 'relative',
													display: 'inline-block',
												}}>
												<div
													style={{
														width: 120,
														height: 140,
														display: 'flex',
														flexDirection: 'column',
														alignItems: 'center',
														justifyContent: 'center',
														background: boxBg,
														border: `1px solid ${boxBorder}`,
														borderRadius: 8,
														cursor: 'pointer',
														overflow: 'hidden',
													}}
													title={
														isPdf
															? 'Click to preview PDF'
															: 'Click to preview image'
													}
													onClick={() =>
														window.open(
															img.url || img.file,
															'_blank',
															'noopener',
														)
													}>
													{isPdf ? (
														<span
															style={{
																fontSize: 40,
																color: '#d32f2f',
																margin: '16px 0 8px 0',
															}}>
															📄
														</span>
													) : (
														<div
															style={{
																width: 90,
																height: 70,
																margin: '12px 0 8px 0',
																borderRadius: 4,
																background: '#2222',
																overflow: 'hidden',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
															}}>
															<img
																src={img.url || img.file}
																alt={img.name}
																style={{
																	width: '100%',
																	height: '100%',
																	objectFit: 'cover',
																	display: 'block',
																}}
															/>
														</div>
													)}
													<span
														style={{
															fontSize: 12,
															color: fileNameColor,
															wordBreak: 'break-all',
															textAlign: 'center',
															margin: '0 6px 0 6px',
															display: '-webkit-box',
															WebkitLineClamp: 2,
															WebkitBoxOrient: 'vertical',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															maxHeight: 32,
															lineHeight: '16px',
														}}>
														{img.name}
													</span>
												</div>
												<button
													type='button'
													style={{
														position: 'absolute',
														top: -8,
														right: -8,
														background: '#f44336',
														color: '#fff',
														border: 'none',
														borderRadius: '50%',
														width: 22,
														height: 22,
														cursor: 'pointer',
														fontWeight: 700,
													}}
													onClick={() => handleDeleteReceipt(img.id)}>
													×
												</button>
											</div>
										);
									})}
									{previewImg && (
										<div
											style={{
												position: 'fixed',
												top: 0,
												left: 0,
												width: '100vw',
												height: '100vh',
												background: 'rgba(0,0,0,0.7)',
												zIndex: 9999,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
											}}
											onClick={() => setPreviewImg(null)}>
											<img
												src={previewImg}
												alt='Preview'
												style={{
													maxWidth: '90vw',
													maxHeight: '90vh',
													borderRadius: 8,
													boxShadow: '0 2px 16px #0008',
												}}
											/>
										</div>
									)}
								</div>
							</div>
						)}
						{effectivePaymentMethod === 'paypal' && (
							<div style={{ marginTop: 12 }}>
								<div style={{ fontWeight: 500, marginBottom: 8 }}>
									You will be redirected to PayPal to complete your payment.
								</div>
								<button
									className='onboarding-btn'
									style={{
										background: '#ffc439',
										color: '#111',
										marginTop: 8,
										fontWeight: 700,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										fontSize: 18,
										border: 'none',
										boxShadow: '0 2px 8px #ffc43944',
										height: 48,
										width: 180,
										padding: 0,
									}}>
									<img src={Paypal} alt='PayPal Logo' style={{ height: '80%' }} />
								</button>
							</div>
						)}
					</div>
				)} */}
			</div>
		);
	};

	const renderStepContent = () => {
		if (step === 0) return renderWelcome();
		if (step === 1) return renderBusinessInfo();
		if (step === 2) return renderChoosePlan();
		if (step === 3) return renderReview();
		if (step === 4) return renderPayment();
		return <div></div>;
	};

	const handleSelectPackage = async (plan, isTrial = false) => {
		try {
			const email = (businessInfo?.email || '').trim();
			if (!email) {
				startmodel();
				setMsgLoadalert(
					'Please enter your business email on the Business Info step to continue.',
				);
				setMsgtypeLoadalert('Error');
				return;
			}

			if (planSubmitting) return;
			setPlanSubmitting(true);

			const payload = {
				action: 'select_package',
				package_id: plan.id,
				is_trail_version: isTrial ? 1 : 0,
				email,
				package_currency:
					String(ipCountryCode || '').toUpperCase() === 'LK' ? 'LKR' : 'USD',
			};

			console.debug('select_package payload', payload);

			const resp = await apiServicewt(payload, navigate);
			console.debug('select_package resp', resp);

			if (resp && (resp.type === 'Success' || resp.type === 'success')) {
				setSelectedPlan(plan);
				setUserClickedButton({ planId: plan.id, isTrialButton: !!isTrial });
				if (resp.data && resp.data.package_details) {
					setGetreviewplan(resp.data.package_details || {});
				}
				return true;
			} else {
				console.debug('select_package failed response', resp);
				startmodel();
				setMsgLoadalert(resp?.message || resp?.error || 'Failed to select package.');
				setMsgtypeLoadalert('error');
				return false;
			}
		} catch (err) {
			console.error('select_package error', err);
			startmodel();
			setMsgLoadalert(err?.message || 'Failed to select package. Please try again.');
			setMsgtypeLoadalert('error');
			return false;
		} finally {
			setPlanSubmitting(false);
		}
	};

	const renderChoosePlan = () => (
		<div style={{ maxWidth: '100%', margin: '0 auto' }}>
			<StepHeader
				title='Choose Your Plan'
				subtitle='Pick a plan that fits your business needs.'
				backLabel='Previous Step'
				onBack={() => setStep(step - 1)}
				onNext={async () => {
					if (planSubmitting) return;
					if (!selectedPlan) {
						startmodel();
						setMsgLoadalert('Please select a plan first.');
						setMsgtypeLoadalert('error');
						return;
					}
					if (!businessInfo?.email) {
						startmodel();
						setMsgLoadalert('Please provide an email in Business Info.');
						setMsgtypeLoadalert('error');
						return;
					}
					setStep((s) => s + 1);
				}}
				nextLabel={planSubmitting ? 'Processing…' : 'Next'}
			/>
			{planesData.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							gap: 12,
						}}>
						<div
							className='spinner-border'
							role='status'
							style={{ width: 48, height: 48, borderWidth: 4 }}>
							<span className='visually-hidden'>Loading plans...</span>
						</div>
					</div>
				</div>
			) : (
				<div
					className='plans-align-wrap'
					onScroll={(e) => {
						const el = e.currentTarget.querySelector('.onboarding-card-scroll-wrap');
						const grid = e.currentTarget.querySelector('.onboarding-card-grid');
						if (!el) return;
						const isScrollable = el.scrollHeight > el.clientHeight + 1;
						const isHScrollable = grid
							? grid.scrollWidth > grid.clientWidth + 1
							: false;
						el.dataset.scroll = isScrollable ? '1' : '0';
						el.dataset.hscroll = isHScrollable ? '1' : '0';
					}}
					ref={(node) => {
						if (!node) return;
						const el = node.querySelector('.onboarding-card-scroll-wrap');
						const grid = node.querySelector('.onboarding-card-grid');
						if (!el) return;
						const isScrollable = el.scrollHeight > el.clientHeight + 1;
						el.dataset.scroll = isScrollable ? '1' : '0';
						const isHScrollable = grid
							? grid.scrollWidth > grid.clientWidth + 1
							: false;
						el.dataset.hscroll = isHScrollable ? '1' : '0';
					}}>
					<div className='onboarding-card-scroll-wrap'>
						<div ref={topScrollRef} className='onboarding-card-top-scroll'>
							<div className='scroll-spacer' />
						</div>
						<div className='onboarding-card-grid' ref={gridScrollRef}>
							{planesData.map((plan) => {
								const cardBg =
									themeStatus === 'dark'
										? selectedPlan && selectedPlan.id === plan.id
											? '#23263a'
											: '#181a25'
										: selectedPlan && selectedPlan.id === plan.id
										? '#eaf0ff'
										: '#f8f9fa';
								const cardBorder = plan.highlight
									? '2px solid #4d69fa'
									: selectedPlan && selectedPlan.id === plan.id
									? '2px solid #4d69fa'
									: '2px solid transparent';
								let cardShadow;
								const defaultLightShadow = '0 6px 18px rgba(15,23,42,0.22)';
								const highlightLightShadow = '0 8px 28px rgba(77,105,250,0.12)';
								const selectedLightShadow = '0 12px 40px rgba(77,105,250,0.18)';
								const pressedLightShadow = '0 14px 48px rgba(77,105,250,0.22)';
								const darkHighlightShadow = '0 4px 24px #4d69fa22';
								const darkSelectedShadow = '0 6px 30px #4d69fa33';

								if (themeStatus === 'dark') {
									if (pressedPlan === plan.id) cardShadow = darkSelectedShadow;
									else if (selectedPlan && selectedPlan.id === plan.id)
										cardShadow = darkSelectedShadow;
									else if (plan.highlight) cardShadow = darkHighlightShadow;
									else cardShadow = undefined;
								} else {
									if (pressedPlan === plan.id) cardShadow = pressedLightShadow;
									else if (selectedPlan && selectedPlan.id === plan.id)
										cardShadow = selectedLightShadow;
									else if (plan.highlight) cardShadow = highlightLightShadow;
									else cardShadow = defaultLightShadow;
								}

								const titleColor = themeStatus === 'dark' ? '#fff' : '#23263a';
								const featureLabelColor =
									themeStatus === 'dark' ? '#aab3d6' : '#888';
								const featureValueColor =
									themeStatus === 'dark' ? '#e6e9ee' : '#222';

								const features = plan.package_features || {};

								const orderedFeatureKeys = [
									'team_members',
									'services',
									'customers',
									'admin_accounts',
									'storage',
									'branches',
									'product',
									'appointments',
									'email_notifications',
									'app_notification',
									'SMS_notifications',
									'booking_reminders',
									'live_payments',
									'custom_payment_gateways',
									'promo_codes',
									'embedded_web',
									'main_modules',
									'cust_mobile_app',
									'emp_mobile_app',
									'email_campaign',
									'free_basic_website',
									'addons',
									'IT_support',
									'localized_timezone',
								];

								const renderFeatureValue = (v) => {
									if (v === '' || v === null || typeof v === 'undefined')
										return 'Unlimited';
									if (String(v).toLowerCase() === 'true') return 'Yes';
									if (String(v).toLowerCase() === 'false') return 'No';
									return v;
								};

								const prettyName = (k) =>
									k.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
								const isFreePlan = (() => {
									const rawPrice = plan.package_price ?? plan.price ?? 0;
									const num = parseFloat(rawPrice) || 0;
									return (
										num === 0 ||
										plan.is_free === true ||
										plan.free === true ||
										String(plan.package_name || '')
											.toLowerCase()
											.includes('free')
									);
								})();
								const isTrialForThisPlan = !isFreePlan;

								return (
									<div
										key={plan.id || plan.name}
										className={`onboarding-card${
											selectedPlan && selectedPlan.id === plan.id
												? ' selected'
												: ''
										}${plan.highlight ? ' popular' : ''}`}
										onMouseDown={() => setPressedPlan(plan.id)}
										onMouseUp={() => setPressedPlan(null)}
										onMouseLeave={() => setPressedPlan(null)}
										onClick={() => {
											if (planSubmitting) return;
											handleSelectPackage(plan, isTrialForThisPlan);
										}}
										style={{
											background: cardBg,
											border: cardBorder,
											boxShadow: cardShadow,
											transition:
												'box-shadow 160ms ease, transform 120ms ease',
											cursor: 'pointer',
										}}>
										<div style={{ paddingBottom: 8 }}>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'space-between',
													alignItems: 'flex-start',
													gap: 12,
												}}>
												<div style={{ flex: 1 }}>
													<div
														className='plan-title'
														style={{
															fontWeight: 700,
															fontSize: 20,
															color: titleColor,
														}}>
														{plan.package_name || plan.name}{' '}
														{plan.highlight && (
															<span
																style={{
																	color: '#4d69fa',
																	fontSize: 13,
																	marginLeft: 6,
																}}>
																(Most Popular)
															</span>
														)}
													</div>
													<div
														style={{
															color: featureLabelColor,
															fontSize: 13,
															marginTop: 6,
														}}>
														<span
															style={{
																color: featureValueColor,
																fontWeight: 600,
																marginRight: 8,
															}}>
															{features.users || plan.users
																? renderFeatureValue(
																		features.users ||
																			plan.users,
																  )
																: 'Unlimited'}
														</span>
														Registered Users
													</div>
													<div
														className='plan-price'
														style={{ fontSize: 28, marginTop: 6 }}>
														{showUSDPlansPrice &&
														plan.package_price_usd != null
															? '$'
															: plan.currency || 'Rs.'}
														{(() => {
															const raw =
																showUSDPlansPrice &&
																plan.package_price_usd != null
																	? plan.package_price_usd
																	: plan.package_price ??
																	  plan.price ??
																	  0;
															const num = parseFloat(raw);
															if (Number.isFinite(num)) {
																return showUSDPlansPrice
																	? num.toLocaleString(
																			undefined,
																			{
																				minimumFractionDigits: 2,
																				maximumFractionDigits: 2,
																			},
																	  )
																	: num.toLocaleString();
															}
															return String(raw ?? '0');
														})()}{' '}
														<span
															style={{
																fontSize: 14,
																color: '#888',
																fontWeight: 400,
															}}>
															/ {plan.period || 'MONTHLY'}
														</span>
													</div>
												</div>
												<div
													style={{
														width: '100%',
														display: 'flex',
														justifyContent: 'center',
													}}>
													<div
														style={{
															display: 'flex',
															flexDirection: 'column',
															gap: 8,
															alignItems: 'center',
															width: '100%',
															maxWidth: 220,
														}}>
														{(() => {
															const isTrialForThisPlan = !isFreePlan; // paid plans use trial flow, free plan uses regular start
															const isTrialSelected =
																(userClickedButton?.planId ===
																	plan.id &&
																	userClickedButton?.isTrialButton ===
																		true) ||
																(selectedPlan &&
																	selectedPlan.id === plan.id &&
																	!isTrialForThisPlan);
															const btnLabel = isFreePlan
																? 'Start Free Plan'
																: 'Start 14-day Free Trial';
															return (
																<button
																	type='button'
																	className='onboarding-btn'
																	style={{
																		width: '100%',
																		background: isTrialSelected
																			? '#4d69fa'
																			: 'transparent',
																		color: isTrialSelected
																			? '#fff'
																			: '#4d69fa',
																		border: '2px solid #4d69fa',
																		margin: 0,
																		fontWeight: 600,
																	}}
																	onClick={(e) => {
																		e.stopPropagation();
																		if (planSubmitting) return;
																		handleSelectPackage(
																			plan,
																			isTrialForThisPlan,
																		);
																	}}
																	disabled={planSubmitting}>
																	{btnLabel}
																</button>
															);
														})()}
													</div>
												</div>
											</div>
										</div>

										<div
											style={{
												fontSize: 13,
												color: '#4d69fa',
												marginBottom: 8,
											}}>
											{plan.note || ''}
										</div>

										<ul
											className='plan-features'
											style={{
												margin: '8px 0 12px 0',
												padding: 0,
												listStyle: 'none',
											}}>
											{orderedFeatureKeys.map((k) => {
												if (typeof features[k] === 'undefined') return null;
												return (
													<li
														key={k}
														style={{
															marginBottom: 6,
															color: featureLabelColor,
															fontSize: 15,
															display: 'flex',
															justifyContent: 'space-between',
															gap: 12,
														}}>
														<span
															style={{ textTransform: 'capitalize' }}>
															{prettyName(k)}
														</span>
														<span
															style={{
																color: featureValueColor,
																fontWeight: 600,
															}}>
															{renderFeatureValue(features[k])}
														</span>
													</li>
												);
											})}

											{Object.keys(features)
												.filter((k) => !orderedFeatureKeys.includes(k))
												.map((k) => (
													<li
														key={k}
														style={{
															marginBottom: 6,
															color: featureLabelColor,
															fontSize: 15,
															display: 'flex',
															justifyContent: 'space-between',
															gap: 12,
														}}>
														<span
															style={{ textTransform: 'capitalize' }}>
															{prettyName(k)}
														</span>
														<span
															style={{
																color: featureValueColor,
																fontWeight: 600,
															}}>
															{renderFeatureValue(features[k])}
														</span>
													</li>
												))}
										</ul>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			)}
		</div>
	);

	const validateBusinessInfo = () => {
		const newErrors = {};
		const bi = businessInfo || {};

		const isEmpty = (v) => !v || String(v).trim().length === 0;
		if (isEmpty(bi.salonName)) {
			newErrors.salonName = '*Required';
		} else if (bi.salonName.trim().length < 2) {
			newErrors.salonName = 'Minimum 2 characters';
		}
		if (isEmpty(bi.projectSlug)) {
			newErrors.projectSlug = '*Required';
		} else if (String(bi.projectSlug).trim().length < 2) {
			newErrors.projectSlug = 'Minimum 2 characters';
		} else {
			const trimmed = String(bi.projectSlug).trim();
			const normalized = slugify(trimmed);
			if (trimmed !== normalized) {
				newErrors.projectSlug = 'Use only lowercase letters, numbers, and hyphens';
			} else if (/^-|-$/.test(normalized)) {
				newErrors.projectSlug = 'Slug can’t start or end with a hyphen';
			}
		}
		if (isEmpty(bi.ownerName)) {
			newErrors.ownerName = '*Required';
		} else if (bi.ownerName.trim().length < 2) {
			newErrors.ownerName = 'Minimum 2 characters';
		}
		if (isEmpty(bi.ownerLastName)) {
			newErrors.ownerLastName = '*Required';
		} else if (bi.ownerLastName.trim().length < 2) {
			newErrors.ownerLastName = 'Minimum 2 characters';
		}
		if (isEmpty(bi.city)) {
			newErrors.city = '*Required';
		} else if (bi.city.trim().length < 2) {
			newErrors.city = 'Minimum 2 characters';
		}
		if (isEmpty(bi.state)) {
			newErrors.state = '*Required';
		} else if (bi.state.trim().length < 2) {
			newErrors.state = 'Minimum 2 characters';
		}
		if (isEmpty(bi.postal_code)) {
			newErrors.postal_code = '*Required';
		} else if (bi.postal_code.trim().length < 2) {
			newErrors.postal_code = 'Minimum 2 characters';
		}
		if (isEmpty(bi.address)) {
			newErrors.address = '*Required';
		} else if (bi.address.trim().length < 5) {
			newErrors.address = 'Enter a complete address';
		}
		if (isEmpty(bi.country)) {
			newErrors.country = '*Required';
		}
		const validatePhone = (raw, fieldName = '', allowDialOnly = false) => {
			const v = String(raw || '').replace(/\s/g, '');

			if (fieldName === 'contactNumber' && !v) {
				return { ok: false, msg: '*Required' };
			}

			if (!v) {
				return { ok: true, normalized: '' };
			}
			let selectedDial = '';
			try {
				const codeKey = bi.country || '' || '';
				const rawDial =
					(countryPhoneCode &&
						(countryPhoneCode[codeKey] ||
							countryPhoneCode[codeKey.toUpperCase()] ||
							countryPhoneCode[codeKey.toLowerCase()])) ||
					'';
				selectedDial = String(rawDial || '').replace('+', '');
			} catch (e) {
				selectedDial = '';
			}
			if (allowDialOnly && selectedDial && (v === `+${selectedDial}` || v === selectedDial)) {
				return { ok: true, normalized: '' };
			}
			const withPlus = v.startsWith('+') ? v : `+${v}`;
			if (withPlus.startsWith('+94')) {
				const local = withPlus.slice(3);
				const localDigits = local.startsWith('0') ? local.slice(1) : local;

				if (!/^\d{9}$/.test(localDigits)) {
					return {
						ok: false,
						msg: 'Phone Number should be 9 digits (or 10 if starting with 0)',
					};
				}
				return { ok: true, normalized: `+94${localDigits}` };
			}
			if (!/^\+\d{7,15}$/.test(withPlus)) {
				return { ok: false, msg: 'Enter a valid phone number' };
			}

			return { ok: true, normalized: withPlus };
		};
		const contactCheck = validatePhone(bi.contactNumber, 'contactNumber');
		if (!contactCheck.ok) {
			newErrors.contactNumber = contactCheck.msg;
		} else if (contactCheck.normalized) {
			bi.contactNumber = contactCheck.normalized;
		}

		if (!isEmpty(bi.whatsappNumber)) {
			const waCheck = validatePhone(bi.whatsappNumber, 'whatsappNumber', true);
			if (!waCheck.ok) {
				newErrors.whatsappNumber = waCheck.msg;
			} else if (waCheck.normalized) {
				bi.whatsappNumber = waCheck.normalized;
			}
		}
		if (isEmpty(bi.email)) {
			newErrors.email = '*Required';
		} else if (!/^\S+@\S+\.\S+$/.test(bi.email)) {
			newErrors.email = 'Enter a valid email address';
		}
		if (isEmpty(bi.businessType)) {
			newErrors.businessType = '*Required';
		} else if (bi.businessType === 'Other' && isEmpty(bi.businessTypeOther)) {
			newErrors.businessTypeOther = '*Required';
		}
		if (!isEmpty(bi.gstVatTaxId) && !/^[A-Za-z0-9\-\s]{3,50}$/.test(bi.gstVatTaxId)) {
			newErrors.gstVatTaxId = 'Invalid tax / GST / VAT id';
		}
		if (isEmpty(bi.currency)) newErrors.currency = '*Required';
		if (isEmpty(bi.language)) newErrors.language = '*Required';
		const timeRe = /^\d{2}:\d{2}$/;
		if (!Array.isArray(bi.hours) || bi.hours.length === 0) {
			newErrors.hours = '*Required';
		} else {
			bi.hours.forEach((h, idx) => {
				if (!h.open) {
					if (!newErrors.hoursOpen) newErrors.hoursOpen = {};
					newErrors.hoursOpen[idx] = '*Required';
				} else if (!timeRe.test(h.open)) {
					if (!newErrors.hoursOpen) newErrors.hoursOpen = {};
					newErrors.hoursOpen[idx] = 'Open time should be in HH:mm format';
				}
				if (!h.close) {
					if (!newErrors.hoursClose) newErrors.hoursClose = {};
					newErrors.hoursClose[idx] = '*Required';
				} else if (!timeRe.test(h.close)) {
					if (!newErrors.hoursClose) newErrors.hoursClose = {};
					newErrors.hoursClose[idx] = 'Close time should be in HH:mm format';
				}
			});
		}

		return newErrors;
	};
	const submitBusinessInfo = async () => {
		const validation = validateBusinessInfo();
		if (Object.keys(validation).length > 0) {
			setErrors(validation);
			return false;
		}
		const trimmedSlug = businessInfo.projectSlug ? String(businessInfo.projectSlug).trim() : '';
		if (!projectSlugValid || projectSlugLastChecked !== slugify(trimmedSlug)) {
			setProjectSlugChecking(true);
			const ok = await doValidateProjectSlug(trimmedSlug, true);
			if (!ok) {
				setErrors((prev) => ({
					...prev,
					projectSlug: projectSlugError || 'Project slug not available',
				}));
				return false;
			}
		}
		const opening_hours = {};
		if (Array.isArray(businessInfo.hours)) {
			businessInfo.hours.forEach((h) => {
				const idx = daysOfWeek.indexOf(h.day);
				if (idx >= 0)
					opening_hours[String(idx + 1)] = { open: h.open || '', close: h.close || '' };
			});
		}
		const extractDial = (raw) => {
			if (!raw) return { code: '', number: '' };
			let s = String(raw).trim();
			if (s.startsWith('+')) s = s.slice(1);
			const codes = Object.values(countryPhoneCode || {})
				.map((c) => String(c || '').replace(/\D/g, ''))
				.filter(Boolean)
				.sort((a, b) => b.length - a.length);
			for (const c of codes) {
				if (s.startsWith(c)) return { code: c, number: s.slice(c.length) };
			}
			for (let len = 3; len >= 1; len--) {
				if (s.length > len) return { code: s.slice(0, len), number: s.slice(len) };
			}
			return { code: '', number: s };
		};

		const contactParts = extractDial(businessInfo.contactNumber);
		const whatsappParts = extractDial(businessInfo.whatsappNumber);

		const payload = {
			action: 'add_business_info',
			salon_name: businessInfo.salonName || '',
			slug: slugify(businessInfo.projectSlug || ''),
			owner_name: businessInfo.ownerName || '',
			owner_last_name: businessInfo.ownerLastName || '',
			city: businessInfo.city || '',
			state: businessInfo.state || '',
			postal_code: businessInfo.postal_code || '',
			business_address: businessInfo.address || '',
			business_address2: businessInfo.address2 || '',
			country: businessInfo.country || '',
			contact_number_code: contactParts.code || '',
			contact_number: contactParts.number || '',
			whatsapp_number_code: whatsappParts.code || '',
			whatsapp_number: whatsappParts.number || '',
			email: businessInfo.email || '',
			business_type:
				businessInfo.businessType === 'Other'
					? businessInfo.businessTypeOther || 'Other'
					: businessInfo.businessType || '',
			gst_vat_tax_id: businessInfo.gstVatTaxId || '',
			currency: businessInfo.currency || '',
			default_language: businessInfo.language || '',
			opening_hours: JSON.stringify(opening_hours),
		};

		if (businessInfo.logoWhite && businessInfo.logoWhite[0]?.file) {
			payload.logo_light = businessInfo.logoWhite[0].file;
		}
		if (businessInfo.logoDark && businessInfo.logoDark[0]?.file) {
			payload.logo_dark = businessInfo.logoDark[0].file;
		}
		if (businessInfo.logoMobile && businessInfo.logoMobile[0]?.file) {
			payload.logo_mobile = businessInfo.logoMobile[0].file;
		}
		if (businessInfo.favicon && businessInfo.favicon[0]?.file) {
			payload.logo_favicon = businessInfo.favicon[0].file;
		}

		setSubmitting(true);
		try {
			const resp = await apiServicewt(payload, navigate);
			setSubmitting(false);
			if (resp && resp.type === 'success') {
				if (resp.is_email_verified === false) {
					const email = payload.email || businessInfo.email || '';
					setEmailToVerify(email);
					setOtpValues(Array(6).fill(''));
					setOtpError('');
					setResendCooldown(30);
					setPendingEmailVerify(true);
					setMsgLoadalert(resp?.message || 'Verification code sent to email');
					setMsgtypeLoadalert('success');
					startmodel();
					return true;
				}
				setStep(2);
				setMsgLoadalert(resp?.message || 'Business info saved');
				setMsgtypeLoadalert('success');
				startmodel();
				return true;
			}
			if (resp && resp.errors && typeof resp.errors === 'object') {
				setErrors((prev) => ({ ...prev, ...resp.errors }));
			} else if (resp && resp.field_errors && typeof resp.field_errors === 'object') {
				setErrors((prev) => ({ ...prev, ...resp.field_errors }));
			} else {
				setMsgLoadalert(resp?.message || 'Failed to save business info');
				setMsgtypeLoadalert(resp?.type || 'error');
				startmodel();
			}
			return false;
		} catch (err) {
			setSubmitting(false);
			console.error('add_business_info failed', err);
			setMsgLoadalert(err?.message || 'Request failed');
			setMsgtypeLoadalert('error');
			startmodel();
			return false;
		}
	};

	const renderBusinessInfo = () => (
		<form
			noValidate
			style={{ maxWidth: '100%', margin: '0 auto' }}
			onSubmit={async (e) => {
				e.preventDefault();
				await submitBusinessInfo();
			}}>
			<StepHeader
				title='Business Information'
				subtitle='Please complete the information below to continue.'
				backLabel='Previous Step'
				onBack={() => setStep(0)}
				onNext={() => submitBusinessInfo()}
				nextLabel={
					projectSlugChecking ? 'Checking url…' : submitting ? 'Submitting…' : 'Next'
				}
				disableNext={projectSlugChecking || submitting}
			/>
			<div className='onboarding-grid'>
				<div style={{ marginTop: 18, position: 'relative' }}>
					<label>Salon Name*</label>
					<div style={{ position: 'relative' }}>
						<input
							className='form-control mb-2 mt-2'
							name='salonName'
							value={businessInfo.salonName}
							onChange={handleBusinessInfoChange}
							required
							style={{
								...(errors.salonName ? { border: '2px solid red' } : {}),
								paddingRight: 40,
							}}
						/>
					</div>
					{errors.salonName && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.salonName}</div>
					)}
				</div>
				<div style={{ gridColumn: 'span 2', marginTop: 18 }}>
					<div style={{ position: 'relative' }}>
						<label>Project URL*</label>
						<InputGroup style={{ display: 'flex', alignItems: 'center' }}>
							<InputGroupText tag='span'>
								https://business.schedulerdesk.net/
							</InputGroupText>
							<input
								className='form-control mb-2 mt-2'
								name='projectSlug'
								value={businessInfo.projectSlug}
								onChange={handleBusinessInfoChange}
								required
								placeholder='your-business'
								style={{
									...(errors.projectSlug ? { border: '2px solid red' } : {}),
									paddingRight: 40,
								}}
							/>
						</InputGroup>
						{projectSlugChecking && (
							<span
								style={{
									position: 'absolute',
									right: 10,
									top: '65%',
									transform: 'translateY(-50%)',
									color: '#888',
									fontSize: 12,
								}}>
								Checking...
							</span>
						)}
						{projectSlugValid && !projectSlugChecking && (
							<span
								style={{
									position: 'absolute',
									right: 10,
									top: '65%',
									transform: 'translateY(-50%)',
									color: 'green',
									fontSize: 18,
								}}>
								✅
							</span>
						)}
						{!projectSlugValid && !projectSlugChecking && projectSlugError && (
							<span
								style={{
									position: 'absolute',
									right: 10,
									top: '65%',
									transform: 'translateY(-50%)',
									color: 'red',
									fontSize: 18,
								}}>
								❌
							</span>
						)}
					</div>
					{(errors.projectSlug || projectSlugError) && (
						<div style={{ color: 'red', fontSize: 12 }}>
							{projectSlugError || errors.projectSlug}
						</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Owner/Manager Name*</label>
					<input
						className='form-control mb-2 mt-2'
						name='ownerName'
						value={businessInfo.ownerName}
						onChange={handleBusinessInfoChange}
						required
						style={errors.ownerName ? { border: '2px solid red' } : {}}
					/>
					{errors.ownerName && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.ownerName}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Owner Last Name*</label>
					<input
						className='form-control mb-2 mt-2'
						name='ownerLastName'
						value={businessInfo.ownerLastName}
						onChange={handleBusinessInfoChange}
						required
						style={errors.ownerLastName ? { border: '2px solid red' } : {}}
					/>
					{errors.ownerLastName && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.ownerLastName}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Business Type*</label>
					<div>
						<Select
							className='mb-2 mt-2'
							name='businessType'
							value={businessInfo.businessType}
							onChange={handleBusinessInfoChange}
							required
							placeholder='Select...'
							style={errors.businessType ? { border: '2px solid red' } : {}}>
							{businessTypes.map((t) => (
								<option key={t} value={t}>
									{t}
								</option>
							))}
						</Select>
					</div>
					{businessInfo.businessType === 'Other' && (
						<div style={{ marginTop: 8 }}>
							<input
								className='mb-2 mt-2'
								name='businessTypeOther'
								value={businessInfo.businessTypeOther}
								onChange={handleBusinessInfoChange}
								placeholder='Please specify your business type'
								required
								style={errors.businessTypeOther ? { border: '2px solid red' } : {}}
							/>
							{errors.businessTypeOther && (
								<div style={{ color: 'red', fontSize: 12 }}>
									{errors.businessTypeOther}
								</div>
							)}
						</div>
					)}
					{errors.businessType && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.businessType}</div>
					)}
				</div>
				<div style={{ gridColumn: 'span 2', marginTop: 18 }}>
					<label>Business Address*</label>
					<input
						className='form-control mb-2 mt-2'
						name='address'
						value={businessInfo.address}
						onChange={handleBusinessInfoChange}
						required
						style={errors.address ? { border: '2px solid red' } : {}}
					/>
					{errors.address && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.address}</div>
					)}
				</div>
				<div style={{ gridColumn: 'span 2', marginTop: 18 }}>
					<label>Business Address 2</label>
					<input
						className='form-control mb-2 mt-2'
						name='address2'
						value={businessInfo.address2}
						onChange={handleBusinessInfoChange}
						required
						style={errors.address2 ? { border: '2px solid red' } : {}}
					/>
					{/* {errors.address2 && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.address2}</div>
					)} */}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Country*</label>
					<Select
						className='mb-2 mt-2'
						name='country'
						value={businessInfo.country}
						onChange={handleBusinessInfoChange}
						required
						placeholder='Select...'
						style={errors.country ? { border: '2px solid red' } : {}}>
						{countryList.map((c) => (
							<option key={c.code} value={c.code}>
								{c.name}
							</option>
						))}
					</Select>
					{errors.country && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.country}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>City*</label>
					<input
						className='form-control mb-2 mt-2'
						name='city'
						value={businessInfo.city}
						onChange={handleBusinessInfoChange}
						required
						style={errors.city ? { border: '2px solid red' } : {}}
					/>
					{errors.city && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.city}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>State*</label>
					<input
						className='form-control mb-2 mt-2'
						name='state'
						value={businessInfo.state}
						onChange={handleBusinessInfoChange}
						required
						style={errors.state ? { border: '2px solid red' } : {}}
					/>
					{errors.state && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.state}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Postal Code (ZIP Code)*</label>
					<input
						className='form-control mb-2 mt-2'
						name='postal_code'
						value={businessInfo.postal_code}
						onChange={handleBusinessInfoChange}
						required
						style={errors.postal_code ? { border: '2px solid red' } : {}}
					/>
					{errors.postal_code && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.postal_code}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Contact Number*</label>
					<PhoneNumberInput
						key={`contact-${phoneKey}`}
						className='mb-2 mt-2'
						value={phoneValues.contactNumber}
						defaultCountryIso={defaultPhoneIso}
						onChange={(val, country) =>
							handlePhoneChange(val, country, 'contactNumber')
						}
						required={true}
						error={!!errors.contactNumber}
					/>
					{errors.contactNumber && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.contactNumber}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>WhatsApp Number</label>
					<PhoneNumberInput
						key={`whatsapp-${phoneKey}`}
						className='mb-2 mt-2'
						value={phoneValues.whatsappNumber}
						defaultCountryIso={defaultPhoneIso}
						onChange={(val, country) =>
							handlePhoneChange(val, country, 'whatsappNumber')
						}
						required={false}
						error={!!errors.whatsappNumber}
					/>
					{errors.whatsappNumber && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.whatsappNumber}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Email Address*</label>
					<input
						className='form-control mb-2 mt-2'
						name='email'
						value={businessInfo.email}
						onChange={handleBusinessInfoChange}
						required
						style={errors.email ? { border: '2px solid red' } : {}}
					/>
					{errors.email && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.email}</div>
					)}
				</div>
				
				<div style={{ marginTop: 18 }}>
					<label>GST / VAT / Tax ID</label>
					<input
						className='form-control mb-2 mt-2'
						name='gstVatTaxId'
						value={businessInfo.gstVatTaxId}
						onChange={handleBusinessInfoChange}
					/>
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Currency*</label>
					<div>
						<Select
							className='mb-2 mt-2'
							name='currency'
							value={businessInfo.currency}
							onChange={handleBusinessInfoChange}
							required
							placeholder='Select...'
							style={errors.currency ? { border: '2px solid red' } : {}}>
							{currencies.map((c) => (
								<option key={c} value={c}>
									{c}
								</option>
							))}
						</Select>
					</div>
					{errors.currency && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.currency}</div>
					)}
				</div>
				<div style={{ marginTop: 18 }}>
					<label>Default Language*</label>
					<div>
						<Select
							className='mb-2 mt-2'
							name='language'
							value={businessInfo.language}
							onChange={handleBusinessInfoChange}
							required
							placeholder='Select...'
							style={errors.language ? { border: '2px solid red' } : {}}>
							{languages.map((l) => (
								<option key={l} value={l}>
									{l}
								</option>
							))}
						</Select>
					</div>
					{errors.language && (
						<div style={{ color: 'red', fontSize: 12 }}>{errors.language}</div>
					)}
				</div>
				<div
					style={{
						gridColumn: 'span 4',
					}}></div>
				<div
					style={{
						gridColumn: 'span 2',
					}}>
					<label
						style={{
							fontWeight: 600,
							fontSize: 16,
							marginBottom: 8,
							display: 'block',
						}}>
						Opening & Closing Hours (per day)
					</label>
					<div
						style={{
							marginBottom: 12,
							border: '1px solid #e0e0e0',
							borderRadius: 8,
							padding: 16,
						}}>
						<div
							style={{
								display: 'flex',
								fontWeight: 600,
								color: '#4d69fa',
								marginBottom: 8,
								gap: 8,
							}}>
							<div style={{ flex: '0 0 25%', minWidth: 80 }}>Day</div>
							<div style={{ flex: '1 1 35%', minWidth: 120 }}>Open</div>
							<div style={{ flex: '1 1 35%', minWidth: 120 }}>Close</div>
						</div>
						{businessInfo.hours.map((h, idx) => {
							const openError = errors.hoursOpen && errors.hoursOpen[idx];
							const closeError = errors.hoursClose && errors.hoursClose[idx];
							const hasError = openError || closeError;

							return (
								<div
									key={h.day}
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 8,
										marginBottom: 8,
									}}>
									<div style={{ flex: '0 0 25%', minWidth: 80 }}>
										{h.day}
										{hasError && (
											<div
												style={{
													color: 'transparent',
													fontSize: 12,
													height: 14,
													width: 14,
												}}></div>
										)}
									</div>
									<div
										className='d-flex flex-column'
										style={{ flex: '1 1 35%', minWidth: 120 }}>
										<TimePicker
											format='HH:mm'
											suffixIcon={
												<ClockCircleOutlined
													style={{
														color:
															themeStatus === 'dark'
																? '#ffffff'
																: '#212529',
													}}
												/>
											}
											value={h.open ? dayjs(h.open, 'HH:mm') : null}
											onChange={(val) =>
												handleHoursChange(
													idx,
													'open',
													val ? val.format('HH:mm') : '',
												)
											}
											popupClassName='custom-timepicker-dropdown'
											className={`ant-picker-input ${
												themeStatus === 'dark'
													? 'dark-theme'
													: 'light-theme'
											}`}
											style={{
												width: '100%',
												backgroundColor:
													themeStatus === 'dark' ? '#212529' : '#f8f9fa',
												color:
													themeStatus === 'dark' ? '#ffffff' : '#212529',
											}}
											minuteStep={5}
											allowClear={false}
											inputReadOnly={true}
											onKeyDown={(e) => e.preventDefault()}
											placeholder='Open time'
										/>
										{openError ? (
											<div
												style={{
													color: 'red',
													fontSize: 12,
													minWidth: 80,
												}}>
												{openError}
											</div>
										) : closeError ? (
											<div
												style={{
													color: 'transparent',
													fontSize: 12,
													minWidth: 80,
												}}>
												-
											</div>
										) : null}
									</div>
									<div>
										<span style={{ fontWeight: 600, color: '#888' }}>-</span>
										{hasError && (
											<div
												style={{
													color: 'transparent',
													fontSize: 12,
													width: 'fit-content',
													height: 14,
												}}>
												-
											</div>
										)}
									</div>
									<div
										className='d-flex flex-column'
										style={{ flex: '1 1 35%', minWidth: 120 }}>
										<TimePicker
											format='HH:mm'
											suffixIcon={
												<ClockCircleOutlined
													style={{
														color:
															themeStatus === 'dark'
																? '#ffffff'
																: '#212529',
													}}
												/>
											}
											value={h.close ? dayjs(h.close, 'HH:mm') : null}
											onChange={(val) =>
												handleHoursChange(
													idx,
													'close',
													val ? val.format('HH:mm') : '',
												)
											}
											popupClassName='custom-timepicker-dropdown'
											className={`ant-picker-input ${
												themeStatus === 'dark'
													? 'dark-theme'
													: 'light-theme'
											}`}
											style={{
												width: '100%',
												backgroundColor:
													themeStatus === 'dark' ? '#212529' : '#f8f9fa',
												color:
													themeStatus === 'dark' ? '#ffffff' : '#212529',
											}}
											minuteStep={5}
											allowClear={false}
											inputReadOnly={true}
											onKeyDown={(e) => e.preventDefault()}
											placeholder='Close time'
										/>
										{closeError ? (
											<div
												style={{
													color: 'red',
													fontSize: 12,
													minWidth: 80,
												}}>
												{closeError}
											</div>
										) : openError ? (
											<div
												style={{
													color: 'transparent',
													fontSize: 12,
													minWidth: 80,
												}}>
												-
											</div>
										) : null}
									</div>
									<div
										className='d-flex flex-column align-items-center ms-2'
										style={{ width: 40, minWidth: 40 }}>
										{idx > 0 && (
											<Button
												color='danger'
												icon='trash'
												iconStyle={{ width: '14px', height: '14px' }}
												onClick={() => handleDeleteDay(idx)}
											/>
										)}
										{hasError && (
											<div
												style={{
													color: 'transparent',
													fontSize: 12,
													height: 14,
													width: 14,
												}}></div>
										)}
									</div>
								</div>
							);
						})}

						{errors.hours && (
							<div style={{ color: 'red', fontSize: 12, marginTop: 8 }}>
								{errors.hours}
							</div>
						)}
						{businessInfo.hours.length < 7 && (
							<button
								type='button'
								className='onboarding-btn'
								style={{ padding: '4px 16px', fontSize: 14, marginTop: 4 }}
								onClick={handleAddDay}
								disabled={
									businessInfo.hours.length >= 7 ||
									daysOfWeek.every((day) =>
										businessInfo.hours.some((h) => h.day === day),
									)
								}>
								+ Add Day
							</button>
						)}
					</div>
				</div>
				<div
					style={{
						gridColumn: 'span 2',
						display: 'flex',
						gap: 18,
						marginBottom: 8,
					}}>
					<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
						<ImageUploader
							label='Site Logo-Light'
							selectedImages={businessInfo.logoWhite}
							onImageSelect={handleLogoChange('logoWhite')}
							onImageDelete={() =>
								setBusinessInfo((prev) => ({ ...prev, logoWhite: [] }))
							}
							maxImages={1}
							minDimensions={{ width: 160, height: 40 }}
							showAddButton={(businessInfo.logoWhite?.length || 0) === 0}
							darkModeStatus={darkModeStatus}
							themeStatus={themeStatus}
						/>
						{errors.logoWhite && (
							<div style={{ color: 'red', fontSize: 12 }}>{errors.logoWhite}</div>
						)}
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
						<ImageUploader
							label='Site Logo-Dark'
							selectedImages={businessInfo.logoDark}
							onImageSelect={handleLogoChange('logoDark')}
							onImageDelete={() =>
								setBusinessInfo((prev) => ({ ...prev, logoDark: [] }))
							}
							maxImages={1}
							minDimensions={{ width: 160, height: 40 }}
							showAddButton={(businessInfo.logoDark?.length || 0) === 0}
							darkModeStatus={darkModeStatus}
							themeStatus={themeStatus}
						/>
						{errors.logoDark && (
							<div style={{ color: 'red', fontSize: 12 }}>{errors.logoDark}</div>
						)}
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
						<ImageUploader
							label='Site Logo-Mobile'
							selectedImages={businessInfo.logoMobile}
							onImageSelect={handleLogoChange('logoMobile')}
							onImageDelete={() =>
								setBusinessInfo((prev) => ({ ...prev, logoMobile: [] }))
							}
							maxImages={1}
							minDimensions={{ width: 80, height: 80 }}
							showAddButton={(businessInfo.logoMobile?.length || 0) === 0}
							darkModeStatus={darkModeStatus}
							themeStatus={themeStatus}
						/>
						{errors.logoMobile && (
							<div style={{ color: 'red', fontSize: 12 }}>{errors.logoMobile}</div>
						)}
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
						<ImageUploader
							label='Website Favicon'
							selectedImages={businessInfo.favicon}
							onImageSelect={handleLogoChange('favicon')}
							onImageDelete={() =>
								setBusinessInfo((prev) => ({ ...prev, favicon: [] }))
							}
							maxImages={1}
							minDimensions={{ width: 32, height: 32 }}
							showAddButton={(businessInfo.favicon?.length || 0) === 0}
							darkModeStatus={darkModeStatus}
							themeStatus={themeStatus}
						/>
						{errors.favicon && (
							<div style={{ color: 'red', fontSize: 12 }}>{errors.favicon}</div>
						)}
					</div>
				</div>

				<CommonCropperModal
					img={cropperImg}
					imgFile={cropperImgFile}
					isOpen={cropperOpen}
					setOpen={setCropperOpen}
					onCloseModal={() => setCropperOpen(false)}
					onComplete={handleCropperComplete}
					aspectRatio={(() => {
						if (cropperTarget === 'logoWhite' || cropperTarget === 'logoDark') {
							return 160 / 40;
						} else if (cropperTarget === 'logoMobile' || cropperTarget === 'favicon') {
							return 1;
						}
						return 4 / 1;
					})()}
					modalWidth={500}
					modalHeight={400}
					cropShape='rect'
					setImg={() => {}}
				/>
			</div>
		</form>
	);

	useEffect(() => {
		if (saved && !hasRestored) {
			const hasProgress = (() => {
				if (!saved) return false;
				if (typeof saved.step === 'number' && saved.step > 0) return true;
				if (saved.selectedPlan) return true;
				if (saved.businessInfo) {
					const b = saved.businessInfo;
					if (
						(b.salonName && String(b.salonName).trim()) ||
						(b.ownerName && String(b.ownerName).trim()) ||
						(b.email && String(b.email).trim())
					)
						return true;
				}
				return false;
			})();

			if (hasProgress) setShowRestoreAlert(true);
		}
	}, []);
	useEffect(() => {
		return () => {
			if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
		};
	}, []);

	const handleStartNew = () => {
		localStorage.removeItem(ONBOARDING_STORAGE_KEY);
		localStorage.removeItem('onboarding-reached-payment');
		setShowRestoreAlert(false);
		setHasRestored(true);
		setStep(0);
		setBusinessInfo(defaultBusinessInfo);
		setSelectedPlan(null);
		setDomainOption('temporary');
		setCustomDomains({ customer: '', employee: '', business: '', webapi: '', cdn: '' });
		setTempDomains({ customer: '', employee: '', business: '', webapi: '', cdn: '' });
		setReviewAccepted(false);
		setTermsAccepted(false);
		setPaymentOption('trial');
		setBankReceipt([]);
		setErrors({});
		setBillingPeriod('monthly');
		setBankInputKey(Date.now());
		setPaymentMethod('bank');
		setLocalBankReceipt([]);
		setBankReceiptError('');
		setPreviewImg(null);
	};

	const handleContinue = () => {
		setShowRestoreAlert(false);
		setHasRestored(true);
		setPhoneKey((prev) => prev + 1);
	};

	return (
		<>
			{showRestoreAlert && (
				<Ralert
					msgloadalert={t(
						'You have an unfinished onboarding. Would you like to continue where you left off or start over?',
					)}
					msgtypeloadalert={t('Continue or Start New?')}
					loadalert={showRestoreAlert}
					closemodel={() => {
						localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
						handleStartNew();
					}}
					confirmbt={() => {
						localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
						handleContinue();
					}}
					closeBtnText={t('Start New')}
					confirmBtnText={t('Continue')}
				/>
			)}
			{loadalert && (
				<Ralert
					msgloadalert={msgloadalert}
					msgtypeloadalert={msgtypeloadalert}
					loadalert={loadalert}
					closemodel={() => {
						closemodel();
					}}
					closeBtnText={t('Close')}
				/>
			)}

			{emailVerifyOpen && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						background: 'rgba(0,0,0,0.5)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 1050,
					}}>
					<div
						style={{
							width: 480,
							maxWidth: '95%',
							background: darkModeStatus ? '#1f2228' : '#fff',
							borderRadius: 12,
							padding: 24,
							boxShadow: darkModeStatus
								? '0 8px 30px rgba(0,0,0,0.6)'
								: '0 6px 18px rgba(0,0,0,0.15)',
							color: darkModeStatus ? '#e6e9ee' : '#222',
						}}>
						<h3
							style={{
								marginTop: 0,
								marginBottom: 8,
								color: darkModeStatus ? '#fff' : '#222',
							}}>
							Verify your email
						</h3>
						<p style={{ marginTop: 0, color: darkModeStatus ? '#bfc6d6' : '#666' }}>
							We sent a 6-digit verification code to <strong>{emailToVerify}</strong>.
							Enter it below to continue.
						</p>
						<div
							style={{
								display: 'flex',
								gap: 8,
								justifyContent: 'center',
								marginTop: 16,
							}}>
							{otpValues.map((v, idx) => (
								<input
									key={idx}
									type='text'
									inputMode='numeric'
									maxLength={1}
									ref={(el) => (otpInputsRef.current[idx] = el)}
									value={v}
									onPaste={(e) => {
										const clip = (e.clipboardData || window.clipboardData)
											.getData('Text')
											.replace(/[^0-9]/g, '')
											.slice(0, 6);
										if (clip.length) {
											const arr = Array(6).fill('');
											for (let i = 0; i < clip.length; i++) arr[i] = clip[i];
											setOtpValues(arr);
											if (clip.length === 6) {
												setOtpError('');
												verifyEmailOtpWithCode(clip);
											} else {
												otpInputsRef.current[
													Math.min(clip.length, 5)
												]?.focus();
											}
										}
									}}
									onChange={(e) => {
										const ch = e.target.value.replace(/[^0-9]/g, '').slice(-1);
										setOtpValues((prev) => {
											const next = [...prev];
											next[idx] = ch;
											return next;
										});
										if (ch && idx < otpValues.length - 1) {
											otpInputsRef.current[idx + 1]?.focus();
										}
									}}
									onKeyDown={(e) => {
										if (e.key === 'Backspace' && !otpValues[idx] && idx > 0) {
											otpInputsRef.current[idx - 1]?.focus();
										}
										if (e.key === 'Enter') {
											verifyEmailOtp();
										}
									}}
									style={{
										width: 46,
										height: 56,
										textAlign: 'center',
										fontSize: 20,
										borderRadius: 8,
										border: darkModeStatus
											? '1px solid #3a3f4a'
											: '1px solid #ddd',
										background: darkModeStatus ? '#141518' : '#fff',
										color: darkModeStatus ? '#fff' : '#222',
									}}
								/>
							))}
						</div>
						{otpError && <div style={{ color: 'red', marginTop: 12 }}>{otpError}</div>}
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								marginTop: 20,
							}}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
								<button
									onClick={() => {
										setEmailVerifyOpen(false);
										setOtpError('');
									}}
									className='btn'
									style={{
										color: darkModeStatus ? '#cfcfcf' : '#555',
										borderColor: darkModeStatus ? '#444' : '#ddd',
										background: 'transparent',
										borderStyle: 'solid',
										borderWidth: 1,
										padding: '6px 12px',
										borderRadius: 6,
									}}>
									Cancel
								</button>
								<button
									onClick={() => verifyEmailOtp()}
									disabled={otpSubmitting}
									className='btn'
									style={{
										backgroundColor: '#4d69fa',
										borderColor: '#4d69fa',
										color: '#fff',
										padding: '8px 14px',
										borderRadius: 8,
										boxShadow: '0 6px 16px rgba(77,105,250,0.24)',
										borderStyle: 'solid',
										borderWidth: 1,
									}}>
									{otpSubmitting ? 'Verifying…' : 'Verify Email'}
								</button>
							</div>
							<div style={{ textAlign: 'right' }}>
								{resendCooldown > 0 ? (
									<span style={{ color: darkModeStatus ? '#bfc6d6' : '#666' }}>
										Resend in {resendCooldown}s
									</span>
								) : (
									<button
										className='btn btn-link'
										style={{ color: '#4d69fa', padding: 0 }}
										onClick={() => resendVerificationCode()}>
										Resend code
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
			<div className='bg-img onboarding-bg'>
				<div
					className='g-3'
					style={{
						position: 'absolute',
						top: 8,
						right: 8,
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
					<div className='col-md-auto'>
						<div className='row g-3'>
							<div className='col-auto'>
								<Popovers trigger='hover' desc='Dark / Light mode'>
									<Button
										{...styledBtn}
										icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
										onClick={() => {
											setDarkModeStatus((prev) => !prev);
											localStorage.setItem(
												'theme',
												!darkModeStatus ? 'dark' : 'light',
											);
										}}
										aria-label='Toggle theme'
									/>
								</Popovers>
							</div>
							<div className='col-auto'>
								<Dropdown>
									<DropdownToggle hasIcon={false}>
										<Button
											{...styledBtn}
											icon={getLangWithKey(i18n.language)?.icon}
											aria-label='Change language'
											data-tour='lang-selector'
										/>
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
										{Object.keys(LANG).map((i) => (
											<DropdownItem key={LANG[i].lng}>
												<Button
													icon={LANG[i].icon}
													onClick={() => changeLanguage(LANG[i].lng)}>
													{LANG[i].text}
												</Button>
											</DropdownItem>
										))}
									</DropdownMenu>
								</Dropdown>
							</div>
						</div>
					</div>
				</div>
				<Page
					className='p-0 mt-3'
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100vh',
						width: '100vw',
						background: 'transparent',
						maxWidth: '95%',
					}}>
					<Card
						className='shadow-3d-dark'
						data-tour='login-page'
						style={{
							width: '95%',
							height: '82%',
							maxWidth: '95%',
							maxHeight: '90%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'stretch',
							padding: '0',
							overflow: 'hidden',
						}}>
						<div
							className='onboarding-stepper'
							style={{
								position: 'sticky',
								top: 0,
								zIndex: 10,
								background: darkModeStatus ? '#242731' : '#f9f9f9',
								padding: '32px 40px 0 40px',
								marginBottom: 0,
								borderTopLeftRadius: 16,
								borderTopRightRadius: 16,
							}}>
							{steps.map((s, i) => (
								<div
									key={s}
									className={`step ${i === step ? 'active' : ''} ${
										i < step ? 'done' : ''
									}`}
									style={{ cursor: 'pointer' }}
									onClick={() => setStep(i)}>
									{s}
								</div>
							))}
						</div>
						<CardBody
							style={{
								flex: 1,
								overflow: 'auto',
								padding: '24px 40px 32px 40px',
								background: darkModeStatus ? '#05050c' : '#fff',
							}}>
							<div className='onboarding-step-content'>{renderStepContent()}</div>
						</CardBody>
					</Card>
				</Page>
			</div>
		</>
	);
};

export default OnboardingSetup;
